/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type ActiveMarket = {
  __typename?: 'ActiveMarket';
  assetId: Scalars['Int']['output'];
  highestBid: ActiveMarketOrder;
  imageFileName?: Maybe<Scalars['String']['output']>;
  isCommunity?: Maybe<Scalars['Boolean']['output']>;
  lowestOffer: ActiveMarketOrder;
  lwin18: Scalars['String']['output'];
  marketValue: Scalars['Float']['output'];
  producer?: Maybe<Scalars['String']['output']>;
  productUrn?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  spread?: Maybe<Scalars['Float']['output']>;
  unitCount: Scalars['Int']['output'];
  unitSize: Scalars['String']['output'];
  vintage: Scalars['Int']['output'];
  wineName: Scalars['String']['output'];
  wineUnitSize?: Maybe<Scalars['Int']['output']>;
};

export type ActiveMarketFilters = {
  bidsAndOffers?: InputMaybe<Scalars['String']['input']>;
  isCommunityHoldings?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unitSize?: InputMaybe<Scalars['String']['input']>;
  vintage?: InputMaybe<Scalars['String']['input']>;
};

export type ActiveMarketFiltersResult = {
  __typename?: 'ActiveMarketFiltersResult';
  price?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  producer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  region?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  score?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unitCount?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unitSize?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vintage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ActiveMarketOrder = {
  __typename?: 'ActiveMarketOrder';
  createdDate?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type ActiveMarketResult = {
  __typename?: 'ActiveMarketResult';
  results: Array<ActiveMarket>;
  total: Scalars['Int']['output'];
};

export type AddExternalPortfolioInput = {
  assetId: Scalars['Int']['input'];
  purchaseDate?: InputMaybe<Scalars['String']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Int']['input'];
};

export type AddToWatchListResponse = {
  __typename?: 'AddToWatchListResponse';
  assetId: Scalars['Int']['output'];
  watchlistItemId: Scalars['Int']['output'];
};

export type Address = {
  __typename?: 'Address';
  addressId: Scalars['ID']['output'];
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  county?: Maybe<Scalars['String']['output']>;
  createdDateTime: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  town: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AddressDeletedResult = {
  __typename?: 'AddressDeletedResult';
  deletedAddressId: Scalars['ID']['output'];
};

export type AddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  county?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  town: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type Appellation = {
  __typename?: 'Appellation';
  appellationAuthority?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentAppellationId?: Maybe<Scalars['Int']['output']>;
  regionId?: Maybe<Scalars['Int']['output']>;
};

export type Asset = {
  __typename?: 'Asset';
  calculatedMarketData?: Maybe<CalculatedMarketData>;
  id: Scalars['Int']['output'];
  isInWatchList: Scalars['Boolean']['output'];
  lwin11?: Maybe<Scalars['String']['output']>;
  lwin18?: Maybe<Scalars['String']['output']>;
  marketData: MarketData;
  marketValue?: Maybe<Scalars['Float']['output']>;
  openOrders: Array<BookedOrder>;
  productUrn?: Maybe<Scalars['String']['output']>;
  provenance?: Maybe<Scalars['String']['output']>;
  recentWineSearcherOffer: OffersResponse;
  releasePrice?: Maybe<Scalars['Float']['output']>;
  spread?: Maybe<OrderSpread>;
  tradingInfo: TradingInfo;
  unitCount: Scalars['Int']['output'];
  unitSize: Scalars['String']['output'];
  unitSizeId?: Maybe<Scalars['Int']['output']>;
  unitVolume?: Maybe<Scalars['Int']['output']>;
  vintage: WineVintage;
  vintages: Array<WineVintage>;
  wineId?: Maybe<Scalars['Int']['output']>;
  wineVintagesId: Scalars['Int']['output'];
};


export type AssetMarketDataArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type AssetSpreadArgs = {
  selectLowestOffer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetInstance = {
  __typename?: 'AssetInstance';
  assetId: Scalars['Int']['output'];
  bondedStatus: Scalars['String']['output'];
  entryDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  linkedToPhysical?: Maybe<Scalars['Boolean']['output']>;
  location: Scalars['String']['output'];
  purchasePrice: Scalars['Float']['output'];
  stockStatus?: Maybe<Scalars['String']['output']>;
  traceability: Scalars['String']['output'];
  transferRequested?: Maybe<Scalars['Boolean']['output']>;
  valuation?: Maybe<Scalars['Float']['output']>;
};

export type AuthChangePasswordInput = {
  clientId: Scalars['String']['input'];
  passwordConfirm: Scalars['String']['input'];
  passwordCurrent: Scalars['String']['input'];
  passwordNew: Scalars['String']['input'];
};

export type AuthChangePasswordResponse = {
  __typename?: 'AuthChangePasswordResponse';
  wasPasswordChanged: Scalars['Boolean']['output'];
};

export type AuthCnLoginRequestInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AuthCnRegisterUserInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  hasAgreedToMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  hasAgreedToTerms?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  registeredByApp: RegisteredByApp;
  registrationType: RegistrationType;
};

export type AuthCnUser = {
  __typename?: 'AuthCnUser';
  accountType?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  isPhoneNumberVerified: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type AuthCreateBiometricRequestInput = {
  biometricPublicKey: Scalars['String']['input'];
};

export type AuthCreateBiometricResponse = {
  __typename?: 'AuthCreateBiometricResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isSuccess: Scalars['Boolean']['output'];
};

export type AuthGetMfaAuthenticatorsRequestInput = {
  mfaToken: Scalars['String']['input'];
};

export type AuthGetMfaAuthenticatorsResponse = {
  __typename?: 'AuthGetMfaAuthenticatorsResponse';
  mfaAuthenticators: Array<AuthMfaAuthenticator>;
};

export type AuthLoginRequestInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  loginByApp?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type AuthLoginResponse = {
  __typename?: 'AuthLoginResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorDescription?: Maybe<Scalars['String']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  mfaToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
  userToken?: Maybe<Scalars['String']['output']>;
};

export type AuthLoginWithBiometricRequestInput = {
  biometricPublicKey: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

export type AuthMfaAuthenticator = {
  __typename?: 'AuthMfaAuthenticator';
  active: Scalars['Boolean']['output'];
  authenticatorType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  oobChannel: Scalars['String']['output'];
};

export type AuthMfaChallengeRequestInput = {
  authenticatorId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  mfaToken: Scalars['String']['input'];
};

export type AuthMfaChallengeResponse = {
  __typename?: 'AuthMfaChallengeResponse';
  challengeType: Scalars['String']['output'];
  oobCode: Scalars['String']['output'];
};

export type AuthMfaOobCodeVerifyRequestInput = {
  biometricPublicKey?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  mfaOobCode: Scalars['String']['input'];
  mfaOtpCode: Scalars['String']['input'];
  mfaToken: Scalars['String']['input'];
};

export type AuthMfaOobCodeVerifyResponse = {
  __typename?: 'AuthMfaOobCodeVerifyResponse';
  accessToken: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  errorDescription?: Maybe<Scalars['String']['output']>;
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
  userToken: Scalars['String']['output'];
};

export type AuthRefreshAccessTokenRequestInput = {
  clientId: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

export type AuthRefreshAccessTokenResponse = {
  __typename?: 'AuthRefreshAccessTokenResponse';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  userToken: Scalars['String']['output'];
};

export type AuthRegisterUserInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  hasAgreedToMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Must be one of "Zellar" or "WebsiteOnboarding" */
  registeredByApp: Scalars['String']['input'];
  residenceCountry?: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
};

export type AuthResendVerificationEmailInput = {
  application?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
};

export type AuthResendVerificationEmailResponse = {
  __typename?: 'AuthResendVerificationEmailResponse';
  wasVerificationEmailResent: Scalars['Boolean']['output'];
};

export type AuthResetPasswordInput = {
  clientId: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
};

export type AuthResetPasswordResponse = {
  __typename?: 'AuthResetPasswordResponse';
  emailAddress: Scalars['String']['output'];
};

export type AuthUpdateUserDtoInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};

export type AuthUser = {
  __typename?: 'AuthUser';
  accountType?: Maybe<Scalars['String']['output']>;
  cultWineId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  isPhoneNumberVerified: Scalars['Boolean']['output'];
  kycStatus?: Maybe<KycStatus>;
  mitConsentedFlag?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  surname: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type AuthUserJwtResponse = {
  __typename?: 'AuthUserJwtResponse';
  /** JWT containing representation of the UserDto */
  userToken?: Maybe<Scalars['String']['output']>;
};

export type BankTransferConfirmResponse = {
  __typename?: 'BankTransferConfirmResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type BankTransferPreferenceInput = {
  accNumber: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  bankAddress: Scalars['String']['input'];
  bankInstitution: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  bic: Scalars['String']['input'];
  company: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  fxRate: Scalars['Float']['input'];
  gbpAmount: Scalars['Float']['input'];
  iban: Scalars['String']['input'];
  reference: Scalars['String']['input'];
  routing: Scalars['String']['input'];
  sortCode: Scalars['String']['input'];
};

export type Bid = {
  __typename?: 'Bid';
  assetId: Scalars['Int']['output'];
  clientOrderId: Scalars['String']['output'];
  direction: Scalars['Int']['output'];
  filledTime: Scalars['String']['output'];
  filledType: TaskStateEnumType;
  id: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  submittedTimeUtc: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type BidOfferModel = {
  __typename?: 'BidOfferModel';
  clientOrderId?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  filledTime?: Maybe<Scalars['String']['output']>;
  filledType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  quantityOutstanding: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type BidsResult = {
  __typename?: 'BidsResult';
  appellation?: Maybe<Scalars['String']['output']>;
  assetId: Scalars['Int']['output'];
  bidStatus: Scalars['String']['output'];
  calculatedMarketData: CalculatedMarketData;
  date: Scalars['String']['output'];
  docId: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  myBid: Scalars['Float']['output'];
  region: Scalars['String']['output'];
  spread?: Maybe<OrderSpread>;
  unitCount: Scalars['Int']['output'];
  unitSize: Scalars['String']['output'];
  vintage: Scalars['Int']['output'];
  wineName: Scalars['String']['output'];
};

export type BookedOrder = {
  __typename?: 'BookedOrder';
  asset: Asset;
  assetId: Scalars['Int']['output'];
  cancelled: Scalars['Boolean']['output'];
  clientOrderId: Scalars['String']['output'];
  direction: Scalars['Int']['output'];
  executableWindow: ExecutableWindow;
  id: Scalars['ID']['output'];
  outstandingQuantity: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  submittedTimeUtc: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type BuyItNowInitiatedInput = {
  assetId: Scalars['Int']['input'];
  fees?: InputMaybe<Array<FeeItems>>;
  quantity: Scalars['Int']['input'];
  totalPrice: Scalars['Float']['input'];
};

export type BuyItNowInitiatedResponse = {
  __typename?: 'BuyItNowInitiatedResponse';
  clientOrderId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  initiated: Scalars['Boolean']['output'];
};

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type CalculatedMarketData = {
  __typename?: 'CalculatedMarketData';
  combinedScore?: Maybe<Scalars['Float']['output']>;
  currentPrice?: Maybe<Scalars['Float']['output']>;
  liquidityScore?: Maybe<Scalars['Float']['output']>;
  lwin11?: Maybe<Scalars['String']['output']>;
  lwin18?: Maybe<Scalars['String']['output']>;
  performance: HoldingPerformanceResponse;
};

export type CancelStripeRecurringPaymentResponse = {
  __typename?: 'CancelStripeRecurringPaymentResponse';
  hasCancelled: Scalars['Boolean']['output'];
  subscriptionId: Scalars['String']['output'];
};

export type CardDetailDeletedResult = {
  __typename?: 'CardDetailDeletedResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type CardDetailResponse = {
  __typename?: 'CardDetailResponse';
  clientName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  defaultMitFlag?: Maybe<Scalars['Boolean']['output']>;
  expiry?: Maybe<Scalars['String']['output']>;
  instrumentId?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  mitConsentedFlag?: Maybe<Scalars['Boolean']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  scheme?: Maybe<Scalars['String']['output']>;
};

export type CardPaymentInput = {
  amount: Scalars['Float']['input'];
  cardToken?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  defaultMitFlag?: InputMaybe<Scalars['Boolean']['input']>;
  failureUrl: Scalars['String']['input'];
  instrumentId?: InputMaybe<Scalars['String']['input']>;
  mitConsentedFlag?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  storeCardFlag?: InputMaybe<Scalars['Boolean']['input']>;
  successUrl: Scalars['String']['input'];
  transactionType?: InputMaybe<Scalars['String']['input']>;
};

export type CardPaymentResponse = {
  __typename?: 'CardPaymentResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Channels = {
  __typename?: 'Channels';
  email: Scalars['Boolean']['output'];
  push: Scalars['Boolean']['output'];
};

export type ChannelsInput = {
  email: Scalars['Boolean']['input'];
  push: Scalars['Boolean']['input'];
};

export type Client = {
  __typename?: 'Client';
  phoneNumber: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ConfirmBankTransferResponse = {
  __typename?: 'ConfirmBankTransferResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isSuccess: Scalars['Boolean']['output'];
};

export type ContactRmInput = {
  contactMethod: Scalars['String']['input'];
  contactMethodValue: Scalars['String']['input'];
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type ContactRmResponse = {
  __typename?: 'ContactRmResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type CosmosAsset = {
  __typename?: 'CosmosAsset';
  id: Scalars['Int']['output'];
  spread?: Maybe<CosmosSpread>;
  unitCount?: Maybe<Scalars['Int']['output']>;
  unitSize?: Maybe<Scalars['String']['output']>;
  vintage?: Maybe<CosmosVintage>;
};

export type CosmosBidOffer = {
  __typename?: 'CosmosBidOffer';
  price?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CosmosCalculatedMarketData = {
  __typename?: 'CosmosCalculatedMarketData';
  combinedScore?: Maybe<Scalars['String']['output']>;
};

export type CosmosExecutableWindow = {
  __typename?: 'CosmosExecutableWindow';
  endTime?: Maybe<Scalars['String']['output']>;
};

export type CosmosRegion = {
  __typename?: 'CosmosRegion';
  name?: Maybe<Scalars['String']['output']>;
};

export type CosmosSpread = {
  __typename?: 'CosmosSpread';
  highestBid?: Maybe<CosmosBidOffer>;
  lowestOffer?: Maybe<CosmosBidOffer>;
  percentageDifference?: Maybe<Scalars['String']['output']>;
};

export type CosmosVintage = {
  __typename?: 'CosmosVintage';
  calculatedMarketData?: Maybe<CalculatedMarketData>;
  id?: Maybe<Scalars['Int']['output']>;
  imageFileName?: Maybe<Scalars['String']['output']>;
  vintage?: Maybe<Scalars['Int']['output']>;
  wine?: Maybe<CosmosWine>;
};

export type CosmosWine = {
  __typename?: 'CosmosWine';
  appellation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CosmosRegion>;
};

export type CreateOrderInput = {
  assetId: Scalars['Int']['input'];
  cancelAt?: InputMaybe<Scalars['String']['input']>;
  fillOrKill?: InputMaybe<Scalars['Boolean']['input']>;
  limitFXExposure?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Int']['input'];
  targetPortfolioId?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type DefaultMitCardInput = {
  instrumentId: Scalars['String']['input'];
};

export type DeleteAccountResponse = {
  __typename?: 'DeleteAccountResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type ExecutableWindow = {
  __typename?: 'ExecutableWindow';
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type ExternalPortfolioAsset = {
  __typename?: 'ExternalPortfolioAsset';
  addedToExternalPortfolioDate: Scalars['String']['output'];
  asset: Asset;
  assetId: Scalars['Int']['output'];
  calculatedMarketData: CalculatedMarketData;
  id: Scalars['Int']['output'];
  purchaseDate?: Maybe<Scalars['String']['output']>;
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  quantityOwned: Scalars['Int']['output'];
  totalPurchasePrice: Scalars['Float']['output'];
};

export type ExternalPortfolioInstance = {
  __typename?: 'ExternalPortfolioInstance';
  id: Scalars['Int']['output'];
  purchaseDate?: Maybe<Scalars['String']['output']>;
  purchasePrice?: Maybe<Scalars['Float']['output']>;
};

export type FeeItems = {
  type: FeeType;
  value: Scalars['Float']['input'];
};

export enum FeeType {
  TRANSACTION_FEES = 'TRANSACTION_FEES',
  VAT_FEES = 'VAT_FEES'
}

export type FinancialAvailableWithdrawalAmount = {
  __typename?: 'FinancialAvailableWithdrawalAmount';
  currentWithdrawalGbp: Scalars['Float']['output'];
};

export type FinancialOperation = {
  __typename?: 'FinancialOperation';
  operationAmountGbp: Scalars['Float']['output'];
  operationCurrency: Scalars['String']['output'];
  operationDate: Scalars['String']['output'];
  operationSource?: Maybe<Scalars['String']['output']>;
  operationType: OperationType;
};

export type FinancialOperationCapitalInvestment = {
  __typename?: 'FinancialOperationCapitalInvestment';
  totalCapitalInvestedGbp: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
};

export type FinancialOperationCurrentBalance = {
  __typename?: 'FinancialOperationCurrentBalance';
  cultWineId: Scalars['String']['output'];
  currentBalanceGbp: Scalars['Float']['output'];
};

export type FinancialOperationInput = {
  operationAmountGbp: Scalars['Float']['input'];
  operationCurrency: Scalars['String']['input'];
  operationDate: Scalars['String']['input'];
  operationSource?: InputMaybe<Scalars['String']['input']>;
  operationType: OperationType;
};

export type FinancialOperationMonthWiseFlow = {
  __typename?: 'FinancialOperationMonthWiseFlow';
  monthlyExpenses: Array<MonthlyExpense>;
};

export type FinancialRecentOperation = {
  __typename?: 'FinancialRecentOperation';
  operationAmountGbp: Scalars['Float']['output'];
  operationCurrency: Scalars['String']['output'];
  operationDate: Scalars['String']['output'];
  operationSource?: Maybe<Scalars['String']['output']>;
  operationType: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type HistoricMarketPriceItem = {
  __typename?: 'HistoricMarketPriceItem';
  date: Scalars['String']['output'];
  marketPrice: Scalars['Float']['output'];
};

export type HistoricalMarketData = {
  __typename?: 'HistoricalMarketData';
  assetId: Scalars['Int']['output'];
  liveX: Scalars['JSON']['output'];
  lwin18: Scalars['String']['output'];
  wineSearcher: Scalars['JSON']['output'];
};

export type HistoricalMarketDataChange = {
  __typename?: 'HistoricalMarketDataChange';
  assetId: Scalars['Int']['output'];
  liveX: Scalars['JSON']['output'];
  lwin18: Scalars['String']['output'];
  wineSearcher: Scalars['JSON']['output'];
};

export type Holding = {
  __typename?: 'Holding';
  assetId: Scalars['Int']['output'];
  buyingTransactionId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  sellingTransactionId?: Maybe<Scalars['String']['output']>;
  soldTransactionDate?: Maybe<Scalars['String']['output']>;
  soldTransactionPrice?: Maybe<Scalars['Float']['output']>;
  unitSizeId: Scalars['Int']['output'];
  vintageId: Scalars['Int']['output'];
};

export type HoldingItem = {
  __typename?: 'HoldingItem';
  activeOfferQuantity: Scalars['Int']['output'];
  totalMarketValuation: Scalars['Float']['output'];
  totalPurchasePrice: Scalars['Float']['output'];
  totalQuantityOwned: Scalars['Int']['output'];
};

export type HoldingPerformanceResponse = {
  __typename?: 'HoldingPerformanceResponse';
  percentageDifference?: Maybe<Scalars['Float']['output']>;
  valueDifference?: Maybe<Scalars['Float']['output']>;
};

export type HoldingPurchaseDateDto = {
  __typename?: 'HoldingPurchaseDateDto';
  purchaseDate?: Maybe<Scalars['String']['output']>;
  purchasePrice?: Maybe<Scalars['Float']['output']>;
};

export type HoldingResponse = {
  __typename?: 'HoldingResponse';
  assetId: Scalars['Int']['output'];
  buyingTransactionId: Scalars['Int']['output'];
  sellingTransactionId?: Maybe<Scalars['Int']['output']>;
  unitSizeId: Scalars['Int']['output'];
  vintageId: Scalars['Int']['output'];
};

export type HoldingResult = {
  __typename?: 'HoldingResult';
  appellation?: Maybe<Scalars['String']['output']>;
  assetId: Scalars['Int']['output'];
  calculatedMarketData: CalculatedMarketData;
  cultWineId: Scalars['String']['output'];
  docId: Scalars['String']['output'];
  drinkingWindow: WineVintageDrinkingWindow;
  holding: HoldingItem;
  marketValue: Scalars['Float']['output'];
  portfolioId: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  spread?: Maybe<OrderSpread>;
  totalPurchasedPrice: Scalars['Float']['output'];
  unitCount: Scalars['Int']['output'];
  unitSize: Scalars['String']['output'];
  vintage: Scalars['Int']['output'];
  wineName: Scalars['String']['output'];
};

export type HoldingTimeSeries = {
  __typename?: 'HoldingTimeSeries';
  date: Scalars['String']['output'];
  holdings: Array<HoldingResponse>;
};

export type HubSpotCustomer = {
  __typename?: 'HubSpotCustomer';
  addressline1?: Maybe<Scalars['String']['output']>;
  addressline2?: Maybe<Scalars['String']['output']>;
  addressline3?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type IBookedOrder = {
  __typename?: 'IBookedOrder';
  assetId: Scalars['Int']['output'];
  direction: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  submittedTimeUtc: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type IFilledOrder = {
  __typename?: 'IFilledOrder';
  assetId: Scalars['Int']['output'];
  direction: Scalars['Int']['output'];
  filledType: OrderFillType;
  id: Scalars['ID']['output'];
  originalOrder: IBookedOrder;
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  submittedTimeUtc: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type IGetSupportMessageByUserId = {
  __typename?: 'IGetSupportMessageByUserId';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<IMessageObject>>>;
};

export type IGetSupportMessageByUserIdInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type IMessageObject = {
  __typename?: 'IMessageObject';
  createdDateTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  sourceQueryId?: Maybe<Scalars['String']['output']>;
  updatedDateTime?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type ISendSupportMessage = {
  __typename?: 'ISendSupportMessage';
  data?: Maybe<ISendSupportMessageData>;
};

export type ISendSupportMessageData = {
  __typename?: 'ISendSupportMessageData';
  errorMessage?: Maybe<Scalars['String']['output']>;
  result?: Maybe<SendMessageResult>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ISendSupportMessageInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  sourceQueryId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type ImsRegionSummary = {
  __typename?: 'ImsRegionSummary';
  regionName: Scalars['String']['output'];
  totalBottles: Scalars['Int']['output'];
};

export type KycInitiateInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  county: Scalars['String']['input'];
  dob: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  town?: InputMaybe<Scalars['String']['input']>;
};

export type KycInitiateResponse = {
  __typename?: 'KycInitiateResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isKycInitiated: Scalars['Boolean']['output'];
};

export enum KycStatus {
  failed = 'failed',
  not_attempted = 'not_attempted',
  pending = 'pending',
  successful = 'successful'
}

export type LiveActiveMarket = {
  __typename?: 'LiveActiveMarket';
  assetId: Scalars['Int']['output'];
  highestBid?: Maybe<ActiveMarketOrder>;
  imageFileName?: Maybe<Scalars['String']['output']>;
  lowestOffer?: Maybe<ActiveMarketOrder>;
  lwin18: Scalars['String']['output'];
  marketValue?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  spread?: Maybe<Scalars['Float']['output']>;
  toBeRemove?: Maybe<Scalars['Boolean']['output']>;
  unitCount?: Maybe<Scalars['Int']['output']>;
  unitSize?: Maybe<Scalars['String']['output']>;
  vintage?: Maybe<Scalars['Int']['output']>;
  wineName?: Maybe<Scalars['String']['output']>;
};

export type LiveActiveMarketResult = {
  __typename?: 'LiveActiveMarketResult';
  result: LiveActiveMarket;
  total: Scalars['Int']['output'];
};

export type MarkNotificationsReadRequest = {
  ids: Array<Scalars['String']['input']>;
  isRead: Scalars['Boolean']['input'];
};

export type MarketData = {
  __typename?: 'MarketData';
  liveX: Scalars['JSON']['output'];
  lwin18?: Maybe<Scalars['String']['output']>;
  performance: HoldingPerformanceResponse;
  wineSearcher: Scalars['JSON']['output'];
};

export type MonthlyExpense = {
  __typename?: 'MonthlyExpense';
  inward: Scalars['Float']['output'];
  monthDate: Scalars['String']['output'];
  monthName: Scalars['String']['output'];
  outward: Scalars['Float']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  accountDeletion: DeleteAccountResponse;
  addAssetToWatchList: AddToWatchListResponse;
  /**
   * Connect device to push notifications
   *
   * Equivalent to POST /UserDeviceTokens
   */
  addUserDeviceToken: UserDeviceToken;
  /**
   * Allow user to change password.
   *
   * Equivalent to POST /Auth/ChangePassword
   */
  authChangePassword: AuthChangePasswordResponse;
  authCnLogin: AuthLoginResponse;
  authCnRegister: AuthCnUser;
  authCreateBiometric: AuthCreateBiometricResponse;
  /**
   * Sign in via Auth0
   *
   * Equivalent to POST /Auth/Login
   */
  authLogin: AuthLoginResponse;
  authLoginWithBiometric: AuthLoginResponse;
  authMfaAuthenticators: AuthGetMfaAuthenticatorsResponse;
  authMfaChallenge: AuthMfaChallengeResponse;
  /** Verify code sent to oob authenticator (e.g. code sent to email) */
  authMfaVerify: AuthMfaOobCodeVerifyResponse;
  /**
   * Get fresh access token from refresh token
   *
   * Equivalent to POST /Auth/RefreshAccessToken
   */
  authRefreshAccessToken: AuthRefreshAccessTokenResponse;
  /** Create new user record and also create equivalent Authentication Provider record */
  authRegister: AuthUser;
  authResendVerificationEmail: AuthResendVerificationEmailResponse;
  /**
   * If there is no user found with the specified address, this endpoint will still return a 200 response.
   *
   * Equivalent to POST /Auth/ResetPassword
   */
  authResetPassword: AuthResetPasswordResponse;
  /**
   * Update user record
   *
   * Equivalent to PUT /Auth/User
   */
  authUserUpdate: AuthUser;
  bankTransferConfirm: BankTransferConfirmResponse;
  bid: Scalars['ID']['output'];
  buyItNow: BuyItNowInitiatedResponse;
  cancelOrder: Scalars['ID']['output'];
  cancelStripeRecurringPayment: CancelStripeRecurringPaymentResponse;
  confirmManualBankTransfer: ConfirmBankTransferResponse;
  createCardPayment: CardPaymentResponse;
  createPaymentResource: Scalars['String']['output'];
  createStripePayment: StripePaymentResponse;
  createStripeRecurringPayment: StripeRecurringPaymentResponse;
  deleteAssetFromWatchList: Scalars['Int']['output'];
  deleteCardDetail: CardDetailDeletedResult;
  externalPortfolioAddExternalPortfolio: Scalars['Int']['output'];
  externalPortfolioDeleteExternalPortfolio: Scalars['Boolean']['output'];
  externalPortfolioRemoveFromExternalPortfolio: Scalars['Int']['output'];
  /** Kyc initiate */
  kycInitiate: KycInitiateResponse;
  /** Equivalent to POST /ReadNotifications */
  markNotificationsRead: Scalars['Boolean']['output'];
  offer: Scalars['ID']['output'];
  portalAuthLogin: AuthLoginResponse;
  portalAuthMfaAuthenticators: AuthGetMfaAuthenticatorsResponse;
  portalAuthMfaChallenge: AuthMfaChallengeResponse;
  portalAuthMfaVerify: AuthMfaOobCodeVerifyResponse;
  portalAuthRegister: AuthUser;
  portalAuthResetPassword: AuthResetPasswordResponse;
  portalBuyWine: PortalProcessWineResponse;
  portalContactRelationshipManger: ContactRmResponse;
  portalDeliverWine: PortalProcessWineResponse;
  portalInvestNow: PortalProcessWineResponse;
  portalSellWine: PortalProcessWineResponse;
  portalUpdatePreferences: PortalClientPreferencesResponse;
  /**
   * Remove device from push notifications
   *
   * Equivalent to DELETE /UserDeviceTokens
   */
  removeUserDeviceToken: Scalars['Boolean']['output'];
  /**
   * Search bids in Elastic Search
   *
   * Equivalent to GET /Search/SearchBid with indexName 'bid'
   */
  searchBids: SearchBidsResult;
  /**
   * Search holdings in Elastic Search
   *
   * Equivalent to GET /Search/SearchHolding with indexName 'holding'
   */
  searchHoldings: SearchHoldingResult;
  /**
   * Search offers in Elastic Search
   *
   * Equivalent to GET /Search/SearchOffer with indexName 'offer'
   */
  searchOffers: SearchOffersResult;
  /**
   * Search watchlist in Elastic Search
   *
   * Equivalent to GET /Search/SearchWatchlist with indexName 'watchlist'
   */
  searchWatchlist: SearchWatchlistResult;
  /**
   * Search wine vintages in Elastic Search
   *
   * Equivalent to GET /Search/SearchWineVintages with indexName 'wine-vintage'
   */
  searchWineVintages: SearchWineVintagesResult;
  searchWineVintagesFacets: SearchWineVintagesFacetsResult;
  transferInventoryOut: Array<Scalars['String']['output']>;
  /**
   * Patch category
   *
   * Equivalent to PATCH /UpdateCategory
   */
  updateCategory: NotificationCategory;
  /**
   * Patch category type
   *
   * Equivalent to PATCH /UpdateCategoryType
   */
  updateCategoryType: NotificationCategoryType;
  updateDefaultMitCard: UpdateDefaultMitCardResponse;
  updateMitConsent: UpdateMitConsentResponse;
  /** Equivalent to Patch /UpdateNotification */
  updateNotification: Notification;
  updateStripeRecurringPayment: UpdateStripeRecurringPaymentResponse;
  withdrawConfirmation: WithdrawConfirmationResponse;
  zellarClientAddAddress: Address;
  zellarClientDeleteAddress: AddressDeletedResult;
  zellarClientUpdateAddress: Address;
};


export type MutationAddAssetToWatchListArgs = {
  assetId: Scalars['Int']['input'];
};


export type MutationAddUserDeviceTokenArgs = {
  deviceId: Scalars['String']['input'];
  platform: Scalars['Int']['input'];
};


export type MutationAuthChangePasswordArgs = {
  changePasswordInput: AuthChangePasswordInput;
};


export type MutationAuthCnLoginArgs = {
  cnLoginRequestInput: AuthCnLoginRequestInput;
};


export type MutationAuthCnRegisterArgs = {
  registerCnUserInput: AuthCnRegisterUserInput;
};


export type MutationAuthCreateBiometricArgs = {
  createBiometricRequestInput: AuthCreateBiometricRequestInput;
};


export type MutationAuthLoginArgs = {
  loginRequestInput: AuthLoginRequestInput;
};


export type MutationAuthLoginWithBiometricArgs = {
  loginRequestInput: AuthLoginWithBiometricRequestInput;
};


export type MutationAuthMfaAuthenticatorsArgs = {
  getMfaAuthenticatorsRequestInput: AuthGetMfaAuthenticatorsRequestInput;
};


export type MutationAuthMfaChallengeArgs = {
  mfaChallengeRequestInput: AuthMfaChallengeRequestInput;
};


export type MutationAuthMfaVerifyArgs = {
  mfaOobCodeVerifyRequestInput: AuthMfaOobCodeVerifyRequestInput;
};


export type MutationAuthRefreshAccessTokenArgs = {
  refreshAccessTokenRequestInput: AuthRefreshAccessTokenRequestInput;
};


export type MutationAuthRegisterArgs = {
  registerUserInput: AuthRegisterUserInput;
};


export type MutationAuthResendVerificationEmailArgs = {
  resendVerificationEmailInput: AuthResendVerificationEmailInput;
};


export type MutationAuthResetPasswordArgs = {
  resetPasswordInput: AuthResetPasswordInput;
};


export type MutationAuthUserUpdateArgs = {
  updateUserInput: AuthUpdateUserDtoInput;
};


export type MutationBankTransferConfirmArgs = {
  request: BankTransferPreferenceInput;
};


export type MutationBidArgs = {
  createOrderInput: CreateOrderInput;
};


export type MutationBuyItNowArgs = {
  buyItNowInitiatedInput?: InputMaybe<BuyItNowInitiatedInput>;
};


export type MutationCancelOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationCancelStripeRecurringPaymentArgs = {
  recurringPaymentId: Scalars['String']['input'];
};


export type MutationCreateCardPaymentArgs = {
  cardPayment: CardPaymentInput;
};


export type MutationCreatePaymentResourceArgs = {
  paymentResource: PaymentResourceInput;
};


export type MutationCreateStripePaymentArgs = {
  stripePayment: StripePaymentInput;
};


export type MutationCreateStripeRecurringPaymentArgs = {
  stripeRecurringPayment: StripeRecurringPaymentInput;
};


export type MutationDeleteAssetFromWatchListArgs = {
  assetId: Scalars['Int']['input'];
};


export type MutationDeleteCardDetailArgs = {
  instrumentId: Scalars['String']['input'];
};


export type MutationExternalPortfolioAddExternalPortfolioArgs = {
  externalPortfolio?: InputMaybe<AddExternalPortfolioInput>;
};


export type MutationExternalPortfolioRemoveFromExternalPortfolioArgs = {
  externalPortfolioId: Scalars['Int']['input'];
};


export type MutationKycInitiateArgs = {
  kycInitiateInput: KycInitiateInput;
};


export type MutationMarkNotificationsReadArgs = {
  request: MarkNotificationsReadRequest;
};


export type MutationOfferArgs = {
  createOrderInput: CreateOrderInput;
};


export type MutationPortalAuthLoginArgs = {
  loginRequestInput: AuthLoginRequestInput;
};


export type MutationPortalAuthMfaAuthenticatorsArgs = {
  getMfaAuthenticatorsRequestInput: AuthGetMfaAuthenticatorsRequestInput;
};


export type MutationPortalAuthMfaChallengeArgs = {
  mfaChallengeRequestInput: AuthMfaChallengeRequestInput;
};


export type MutationPortalAuthMfaVerifyArgs = {
  mfaOobCodeVerifyRequestInput: AuthMfaOobCodeVerifyRequestInput;
};


export type MutationPortalAuthRegisterArgs = {
  registerUserInput: PortalAuthRegisterUserInput;
};


export type MutationPortalAuthResetPasswordArgs = {
  resetPasswordInput: AuthResetPasswordInput;
};


export type MutationPortalBuyWineArgs = {
  portalBuyWineRequest: PortalBuyWineRequestInput;
};


export type MutationPortalContactRelationshipMangerArgs = {
  request: ContactRmInput;
};


export type MutationPortalDeliverWineArgs = {
  portalDeliverWineRequest: PortalDeliverWineRequestInput;
};


export type MutationPortalInvestNowArgs = {
  portalInvestNowRequest: PortalInvestNowRequestInput;
};


export type MutationPortalSellWineArgs = {
  portalSellWineRequest: PortalSellWineRequestInput;
};


export type MutationPortalUpdatePreferencesArgs = {
  request: UpdatePreferencesInput;
};


export type MutationRemoveUserDeviceTokenArgs = {
  id: Scalars['String']['input'];
};


export type MutationSearchBidsArgs = {
  filterNames: Array<Scalars['String']['input']>;
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  preQueryString?: InputMaybe<Scalars['String']['input']>;
  queryString: Scalars['String']['input'];
  sortFilter?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSearchHoldingsArgs = {
  filterNames: Array<Scalars['String']['input']>;
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  preQueryString?: InputMaybe<Scalars['String']['input']>;
  queryString: Scalars['String']['input'];
  sortFilter?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSearchOffersArgs = {
  filterNames: Array<Scalars['String']['input']>;
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  preQueryString?: InputMaybe<Scalars['String']['input']>;
  queryString: Scalars['String']['input'];
  sortFilter?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSearchWatchlistArgs = {
  filterNames: Array<Scalars['String']['input']>;
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  preQueryString?: InputMaybe<Scalars['String']['input']>;
  queryString: Scalars['String']['input'];
  sortFilter?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSearchWineVintagesArgs = {
  filterNames: Array<Scalars['String']['input']>;
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  preQueryString?: InputMaybe<Scalars['String']['input']>;
  queryString: Scalars['String']['input'];
  sortFilter?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSearchWineVintagesFacetsArgs = {
  filterNames: Array<Scalars['String']['input']>;
  preQueryString?: InputMaybe<Scalars['String']['input']>;
  queryString: Scalars['String']['input'];
};


export type MutationTransferInventoryOutArgs = {
  assetUnitIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
};


export type MutationUpdateCategoryTypeArgs = {
  id: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
};


export type MutationUpdateDefaultMitCardArgs = {
  defaultMitCard: DefaultMitCardInput;
};


export type MutationUpdateMitConsentArgs = {
  updateMitConsentInput: UpdateMitConsentInput;
};


export type MutationUpdateNotificationArgs = {
  id: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
};


export type MutationUpdateStripeRecurringPaymentArgs = {
  request: UpdateStripeRecurringPaymentInput;
};


export type MutationWithdrawConfirmationArgs = {
  input: WithdrawConfirmationInput;
};


export type MutationZellarClientAddAddressArgs = {
  address: AddressInput;
};


export type MutationZellarClientDeleteAddressArgs = {
  addressId: Scalars['String']['input'];
};


export type MutationZellarClientUpdateAddressArgs = {
  address: AddressInput;
  addressId: Scalars['String']['input'];
};

export type MyTrades = {
  __typename?: 'MyTrades';
  asset: Asset;
  assetId: Scalars['Int']['output'];
  bid: Bid;
  bookingEngineId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  offer: Offer;
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalPrice: Scalars['Float']['output'];
  tradeTime: Scalars['String']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  assetId?: Maybe<Scalars['Int']['output']>;
  category: Scalars['String']['output'];
  createdDateTime: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  summary: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedDateTime?: Maybe<Scalars['String']['output']>;
};

export type NotificationCategory = {
  __typename?: 'NotificationCategory';
  channels?: Maybe<Channels>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<NotificationCategoryType>>;
};

export type NotificationCategoryType = {
  __typename?: 'NotificationCategoryType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type NotificationCategoryTypeInput = {
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type NotificationRequest = {
  __typename?: 'NotificationRequest';
  assetId?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdDateTime: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  pushData?: Maybe<Scalars['JSON']['output']>;
  summary: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedDateTime?: Maybe<Scalars['String']['output']>;
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  from: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<Notification>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type NotificationSettingsResponse = {
  __typename?: 'NotificationSettingsResponse';
  categories: Array<NotificationCategory>;
};

export type Offer = {
  __typename?: 'Offer';
  assetId: Scalars['Int']['output'];
  clientOrderId: Scalars['String']['output'];
  direction: Scalars['Int']['output'];
  filledTime: Scalars['String']['output'];
  filledType: TaskStateEnumType;
  id: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  submittedTimeUtc: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type OffersResponse = {
  __typename?: 'OffersResponse';
  offers: Array<WineSearcherOffer>;
};

export type OffersResult = {
  __typename?: 'OffersResult';
  appellation?: Maybe<Scalars['String']['output']>;
  assetId: Scalars['Int']['output'];
  calculatedMarketData: CalculatedMarketData;
  date: Scalars['String']['output'];
  docId: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  myOffer: Scalars['Float']['output'];
  offerStatus: Scalars['String']['output'];
  region: Scalars['String']['output'];
  spread?: Maybe<OrderSpread>;
  unitCount: Scalars['Int']['output'];
  unitSize: Scalars['String']['output'];
  vintage: Scalars['Int']['output'];
  wineName: Scalars['String']['output'];
};

export enum OperationType {
  Adjustment = 'Adjustment',
  Fresh = 'Fresh',
  Purchase = 'Purchase',
  Refund = 'Refund',
  Sale = 'Sale'
}

export type Order = {
  __typename?: 'Order';
  asset: CosmosAsset;
  cancelled?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  executableWindow?: Maybe<CosmosExecutableWindow>;
  id: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type OrderBook = {
  __typename?: 'OrderBook';
  assetId: Scalars['Int']['output'];
  bids?: Maybe<Array<Maybe<OrderBookdBidOffer>>>;
  lastTradeDate?: Maybe<Scalars['String']['output']>;
  offers?: Maybe<Array<Maybe<OrderBookdBidOffer>>>;
};

export type OrderBookdBidOffer = {
  __typename?: 'OrderBookdBidOffer';
  direction: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  quantityOutstanding: Scalars['Int']['output'];
};

export enum OrderFillType {
  _1 = '_1',
  _2 = '_2'
}

export type OrderSpread = {
  __typename?: 'OrderSpread';
  highestBid?: Maybe<SpreadOrder>;
  lowestOffer?: Maybe<SpreadOrder>;
  percentageDifference?: Maybe<Scalars['Float']['output']>;
};

export type PaymentResourceInput = {
  amount: Scalars['Float']['input'];
  returnUri: Scalars['String']['input'];
};

export type PortaBalanceAndInvestmentValues = {
  __typename?: 'PortaBalanceAndInvestmentValues';
  balances?: Maybe<Array<Maybe<PortalCashBalanceItem>>>;
  todayInvestment: Scalars['Float']['output'];
};

export type PortalAnnualisedReturnItem = {
  __typename?: 'PortalAnnualisedReturnItem';
  date: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type PortalAuthRegisterUserInput = {
  emailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  registeredByApp: Scalars['String']['input'];
  residenceCountry?: InputMaybe<Scalars['String']['input']>;
};

export type PortalBuyWineRequestInput = {
  holdingId: Scalars['String']['input'];
  purchasePrice: Scalars['Float']['input'];
  qty: Scalars['Int']['input'];
  requestPrice: Scalars['Float']['input'];
};

export type PortalCashBalanceItem = {
  __typename?: 'PortalCashBalanceItem';
  balance: Scalars['Float']['output'];
  portfolioId?: Maybe<Scalars['Int']['output']>;
  portfolioName: Scalars['String']['output'];
};

export type PortalClientPreferencesResponse = {
  __typename?: 'PortalClientPreferencesResponse';
  annualManagementFeePayType?: Maybe<Scalars['String']['output']>;
  autoTrade?: Maybe<Scalars['Boolean']['output']>;
  bankTransferChaseEmailCount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  firstLoginDate?: Maybe<Scalars['String']['output']>;
  historicManagementFeePayType?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  managementFeePayment?: Maybe<Scalars['String']['output']>;
};

export type PortalCurrentHoldingItem = {
  __typename?: 'PortalCurrentHoldingItem';
  changedPct: Scalars['Float']['output'];
  costPerUnit: Scalars['Float']['output'];
  costWithMgmtFeePerUnit: Scalars['Float']['output'];
  cultWinesAllocationRegion: Scalars['String']['output'];
  dealCCY?: Maybe<Scalars['String']['output']>;
  dealDate: Scalars['String']['output'];
  dealRef: Scalars['String']['output'];
  historicMarketPrices?: Maybe<Array<Maybe<HistoricMarketPriceItem>>>;
  id: Scalars['String']['output'];
  imageFileName?: Maybe<Scalars['String']['output']>;
  lwin11: Scalars['String']['output'];
  lwin18: Scalars['String']['output'];
  mgmtFeePerUnit: Scalars['Float']['output'];
  netPosition: Scalars['Float']['output'];
  netPositionPerUnit: Scalars['Float']['output'];
  portfolioId: Scalars['Int']['output'];
  priceForSale?: Maybe<Scalars['Float']['output']>;
  profitAndLoss: Scalars['Float']['output'];
  profitAndLossPerUnit: Scalars['Float']['output'];
  qty: Scalars['Int']['output'];
  qtyForSale: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
  totalCostWithMgmtFee: Scalars['Float']['output'];
  totalMgmtFee: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  unitCount: Scalars['Int']['output'];
  valuePerBottle: Scalars['Float']['output'];
  valuePerUnit: Scalars['Float']['output'];
  vintage?: Maybe<Scalars['Int']['output']>;
  wineName: Scalars['String']['output'];
};

export type PortalDeliverWineRequestInput = {
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  address3: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  holdingId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  qty: Scalars['Int']['input'];
  rotationNumber?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type PortalEmailValidationResponse = {
  __typename?: 'PortalEmailValidationResponse';
  status?: Maybe<PortalEmailValidationStatus>;
};

export enum PortalEmailValidationStatus {
  Invalid = 'Invalid',
  Registered = 'Registered',
  Valid = 'Valid'
}

export type PortalEstimateManagementFeeResponse = {
  __typename?: 'PortalEstimateManagementFeeResponse';
  annualFeeAmount: Scalars['Float']['output'];
  discountPct: Scalars['Float']['output'];
  discountedAnnualFeeAmount: Scalars['Float']['output'];
  monthlyFeeAmount: Scalars['Float']['output'];
};

export type PortalExternalHoldingItem = {
  __typename?: 'PortalExternalHoldingItem';
  cashOffer: Scalars['Float']['output'];
  changedPct?: Maybe<Scalars['Float']['output']>;
  costPerUnit?: Maybe<Scalars['Float']['output']>;
  createdDate: Scalars['String']['output'];
  cultWinesAllocationRegion: Scalars['String']['output'];
  imageFileName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lwin11: Scalars['String']['output'];
  lwin18: Scalars['String']['output'];
  netPosition?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalValue: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  unitCount: Scalars['Int']['output'];
  valuePerUnit: Scalars['Float']['output'];
  vintage?: Maybe<Scalars['Int']['output']>;
  wineName: Scalars['String']['output'];
};

export type PortalHoldingDetails = {
  __typename?: 'PortalHoldingDetails';
  changedPct: Scalars['Float']['output'];
  costPerUnit: Scalars['Float']['output'];
  costWithMgmtFeePerUnit: Scalars['Float']['output'];
  cultWinesAllocationRegion: Scalars['String']['output'];
  dealCCY?: Maybe<Scalars['String']['output']>;
  dealDate: Scalars['String']['output'];
  dealRef: Scalars['String']['output'];
  historicMarketPrices?: Maybe<Array<Maybe<HistoricMarketPriceItem>>>;
  holdingStocks?: Maybe<Array<Maybe<PortalHoldingStockItem>>>;
  id: Scalars['String']['output'];
  imageFileName?: Maybe<Scalars['String']['output']>;
  lwin11: Scalars['String']['output'];
  lwin18: Scalars['String']['output'];
  mgmtFeePerUnit: Scalars['Float']['output'];
  netPosition: Scalars['Float']['output'];
  netPositionPerUnit: Scalars['Float']['output'];
  portfolioId: Scalars['Int']['output'];
  priceForSale?: Maybe<Scalars['Float']['output']>;
  profitAndLoss: Scalars['Float']['output'];
  profitAndLossPerUnit: Scalars['Float']['output'];
  qty: Scalars['Int']['output'];
  qtyForSale: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
  totalCostWithMgmtFee: Scalars['Float']['output'];
  totalMgmtFee: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  unitCount: Scalars['Int']['output'];
  valuePerBottle: Scalars['Float']['output'];
  valuePerUnit: Scalars['Float']['output'];
  vintage?: Maybe<Scalars['Int']['output']>;
  wineName: Scalars['String']['output'];
};

export type PortalHoldingStockItem = {
  __typename?: 'PortalHoldingStockItem';
  location?: Maybe<Scalars['String']['output']>;
  rotationNumber: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type PortalInvestNowRequestInput = {
  numberOfUnits: Scalars['Int']['input'];
  offerExpiryDate: Scalars['String']['input'];
  offerPrice: Scalars['Float']['input'];
  offerSubTitle: Scalars['String']['input'];
  offerTitle: Scalars['String']['input'];
  totalPrice: Scalars['Float']['input'];
};

export type PortalManagementFeeResponse = {
  __typename?: 'PortalManagementFeeResponse';
  accountHolderName: Scalars['String']['output'];
  appliedPct?: Maybe<Scalars['Float']['output']>;
  clientName: Scalars['String']['output'];
  feeAmount: Scalars['Float']['output'];
  feeType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  offsetValue?: Maybe<Scalars['Float']['output']>;
  portfolioValue?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  valuationDate: Scalars['String']['output'];
  vintradeAccountHolderId: Scalars['Int']['output'];
  vintradeClientId: Scalars['String']['output'];
};

export type PortalMyCellarItem = {
  __typename?: 'PortalMyCellarItem';
  cultWinesAllocationRegion: Scalars['String']['output'];
  dealCCY?: Maybe<Scalars['String']['output']>;
  dealDate: Scalars['String']['output'];
  dealRef: Scalars['String']['output'];
  holdingId: Scalars['String']['output'];
  imageFileName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lwin11: Scalars['String']['output'];
  lwin18: Scalars['String']['output'];
  portfolioId: Scalars['Int']['output'];
  qty: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  rotationNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stockId?: Maybe<Scalars['String']['output']>;
  unit: Scalars['String']['output'];
  unitCount: Scalars['Int']['output'];
  vintage?: Maybe<Scalars['Int']['output']>;
  wineName: Scalars['String']['output'];
};

export type PortalMyCellarWineDetailsItem = {
  __typename?: 'PortalMyCellarWineDetailsItem';
  changedPct: Scalars['Float']['output'];
  costPerUnit: Scalars['Float']['output'];
  costWithMgmtFeePerUnit: Scalars['Float']['output'];
  cultWinesAllocationRegion: Scalars['String']['output'];
  dealCCY?: Maybe<Scalars['String']['output']>;
  dealDate: Scalars['String']['output'];
  dealRef: Scalars['String']['output'];
  historicMarketPrices?: Maybe<Array<Maybe<HistoricMarketPriceItem>>>;
  id: Scalars['String']['output'];
  imageFileName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lwin11: Scalars['String']['output'];
  lwin18: Scalars['String']['output'];
  mgmtFeePerUnit: Scalars['Float']['output'];
  netPosition: Scalars['Float']['output'];
  netPositionPerUnit: Scalars['Float']['output'];
  portfolioId: Scalars['Int']['output'];
  priceForSale?: Maybe<Scalars['Float']['output']>;
  profitAndLoss: Scalars['Float']['output'];
  profitAndLossPerUnit: Scalars['Float']['output'];
  qty: Scalars['Int']['output'];
  qtyForSale: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  rotationNumber: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  stockId: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
  totalCostWithMgmtFee: Scalars['Float']['output'];
  totalMgmtFee: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  unitCount: Scalars['Int']['output'];
  valuePerBottle: Scalars['Float']['output'];
  valuePerUnit: Scalars['Float']['output'];
  vintage?: Maybe<Scalars['Int']['output']>;
  wineName: Scalars['String']['output'];
};

export type PortalOutstandingManagementFeeResponse = {
  __typename?: 'PortalOutstandingManagementFeeResponse';
  partialOutstandingFeesAmount?: Maybe<Scalars['Float']['output']>;
  totalOutstandingFeesAmount?: Maybe<Scalars['Float']['output']>;
};

export type PortalPerformanceHistoricItem = {
  __typename?: 'PortalPerformanceHistoricItem';
  currentHoldings: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  netContributions: Scalars['Float']['output'];
};

export type PortalPortfolioAnnualisedReturn = {
  __typename?: 'PortalPortfolioAnnualisedReturn';
  monthly?: Maybe<Array<PortalAnnualisedReturnItem>>;
  years?: Maybe<Array<PortalAnnualisedReturnItem>>;
};

export type PortalPortfolioCurrentAllocationItem = {
  __typename?: 'PortalPortfolioCurrentAllocationItem';
  StrategicAllocation: Scalars['Float']['output'];
  currentAllocation: Scalars['Float']['output'];
  regionName: Scalars['String']['output'];
  tacticalAllocation: Scalars['Float']['output'];
};

export type PortalPortfolioCurrentAllocationResponse = {
  __typename?: 'PortalPortfolioCurrentAllocationResponse';
  portalPortfolioCurrentAllocation?: Maybe<Array<Maybe<PortalPortfolioCurrentAllocationItem>>>;
  portalRegionPerformances: Array<PortalRegionPerformanceItem>;
};

export type PortalPortfolioPerformanceItem = {
  __typename?: 'PortalPortfolioPerformanceItem';
  balance: Scalars['Float']['output'];
  balancePending: Scalars['Float']['output'];
  capitalInvested: Scalars['Float']['output'];
  currentFeeModel: Scalars['Boolean']['output'];
  currentHoldings: Scalars['Float']['output'];
  feeModel?: Maybe<Scalars['String']['output']>;
  firstDealDate?: Maybe<Scalars['String']['output']>;
  netContributions: Scalars['Float']['output'];
  netPosition: Scalars['Float']['output'];
  netPositionPct: Scalars['Float']['output'];
  netProceedsFromSales: Scalars['Float']['output'];
  portfolioId?: Maybe<Scalars['Int']['output']>;
  portfolioName: Scalars['String']['output'];
  profitAndLoss: Scalars['Float']['output'];
  profitAndLossPct: Scalars['Float']['output'];
  totalMgmtFee: Scalars['Float']['output'];
  totalRefunds: Scalars['Float']['output'];
};

export type PortalProcessWineResponse = {
  __typename?: 'PortalProcessWineResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type PortalRegionPerformanceItem = {
  __typename?: 'PortalRegionPerformanceItem';
  currentHoldings: Scalars['Float']['output'];
  netPosition: Scalars['Float']['output'];
  netPositionPct: Scalars['Float']['output'];
  regionName: Scalars['String']['output'];
  totalPurchasePrice: Scalars['Float']['output'];
};

export type PortalSellWineRequestInput = {
  holdingId: Scalars['String']['input'];
  marketPrice: Scalars['Float']['input'];
  qty: Scalars['Int']['input'];
  reasonForSale: Scalars['String']['input'];
  reservePrice: Scalars['Float']['input'];
};

export type PortalSoldHoldingItem = {
  __typename?: 'PortalSoldHoldingItem';
  changedPct: Scalars['Float']['output'];
  costPerUnit: Scalars['Float']['output'];
  costWithMgmtFeePerUnit: Scalars['Float']['output'];
  cultWinesAllocationRegion: Scalars['String']['output'];
  dealDate: Scalars['String']['output'];
  dealRef: Scalars['String']['output'];
  imageFileName?: Maybe<Scalars['String']['output']>;
  lwin11: Scalars['String']['output'];
  lwin18: Scalars['String']['output'];
  mgmtFeePerUnit: Scalars['Float']['output'];
  netPosition: Scalars['Float']['output'];
  netPositionPerUnit: Scalars['Float']['output'];
  portfolioId: Scalars['Int']['output'];
  profitAndLoss: Scalars['Float']['output'];
  profitAndLossPerUnit: Scalars['Float']['output'];
  qtySold: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  soldDate: Scalars['String']['output'];
  soldPricePerUnit: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
  totalCostWithMgmtFee: Scalars['Float']['output'];
  totalMgmtFee: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  unitCount: Scalars['Int']['output'];
  vintage?: Maybe<Scalars['Int']['output']>;
  wineName: Scalars['String']['output'];
};

export type PortfolioHighlights = {
  __typename?: 'PortfolioHighlights';
  portfolioValue: Scalars['Float']['output'];
  simpleReturn: Scalars['Float']['output'];
  totalContributions: Scalars['Float']['output'];
};

export type Producer = {
  __typename?: 'Producer';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  authUser: AuthUser;
  authUserJwt: AuthUserJwtResponse;
  /**
   * Returns user's available balance against which he can make bids
   *
   * Equivalent to GET /api/AvailableBalance/AvailableBalance
   */
  availableBalance: Scalars['Float']['output'];
  availableWithdrawalAmount?: Maybe<FinancialAvailableWithdrawalAmount>;
  calculatedMarketData: CalculatedMarketData;
  customerCards?: Maybe<Array<StripeCardItem>>;
  externalPortfolioUserAssetInstances: Array<ExternalPortfolioInstance>;
  externalPortfolioUserAssets: Array<ExternalPortfolioAsset>;
  externalPortfolioUserHasAsset: Scalars['Boolean']['output'];
  financeCurrentBalance?: Maybe<FinancialOperationCurrentBalance>;
  financeGetMonthlyWiseFlowByMonthRange?: Maybe<FinancialOperationMonthWiseFlow>;
  financeGetRecent: Array<FinancialRecentOperation>;
  financeTotalCapitalInvested?: Maybe<FinancialOperationCapitalInvestment>;
  gainAndLoses: Scalars['Float']['output'];
  getActiveMarketsFilters?: Maybe<ActiveMarketFiltersResult>;
  /** Get HubSpot Customer */
  getCustomer: HubSpotCustomer;
  getSupportMessageByUserId?: Maybe<IGetSupportMessageByUserId>;
  getWineMatrixFilters?: Maybe<WineMatrixFiltersResult>;
  historicalMarketValue: Array<HistoricalMarketData>;
  historicalMarketValueChange: Array<HistoricalMarketDataChange>;
  holdingGetUserHoldingsMarketPrice: Scalars['Float']['output'];
  holdingsCurrent: Array<UserHolding>;
  imsRegionSummary: Array<ImsRegionSummary>;
  inventoriesByDatetimeRange: Scalars['JSON']['output'];
  isAssetExistInAnyHoldings: Scalars['Boolean']['output'];
  isUserHoldingHasAsset: Scalars['Boolean']['output'];
  /** Get market depending on the parameters */
  marketData: MarketData;
  /**
   * Returns a list of all the trades for a specific asset
   *
   * Equivalent to GET /api/OrderBooking/AllTradesByAsset
   */
  omsAllTradesByAsset: Array<Trade>;
  /**
   * Returns a list of users orders
   * Equivalent to GET /api/OrderBooking/MyOrders
   */
  omsGetMyOrders: Array<BookedOrder>;
  /**
   * Returns a list of users trades
   * Equivalent to GET /api/OrderBooking/MyTrades
   */
  omsGetMyTrades: Array<MyTrades>;
  /** Returns highest bid and lowest offer for given asset id */
  omsSpreadByAssetId: OrderSpread;
  /**
   * Returns a list of all the booked orders for a specific Id
   *
   * Equivalent to GET /api/OrderBooking/AllOrdersByAssetId
   */
  openOrders: Array<BookedOrder>;
  paymentGetCardDetails?: Maybe<Array<CardDetailResponse>>;
  paymentReferenceNumber?: Maybe<Scalars['String']['output']>;
  /** Portal client cash balance */
  portalCashBalance: PortaBalanceAndInvestmentValues;
  portalClientPreferences?: Maybe<PortalClientPreferencesResponse>;
  /** Portal portfolio current holdings */
  portalCurrentHoldings: Array<PortalCurrentHoldingItem>;
  /** Get Customer Estimate Management Fees */
  portalEstimateManagementFee: PortalEstimateManagementFeeResponse;
  /** Portal portfolio external holdings */
  portalExternalHoldings?: Maybe<Array<PortalExternalHoldingItem>>;
  /** Portal portfolio holding details */
  portalHoldingDetails?: Maybe<PortalHoldingDetails>;
  /** Get Customer Management Fees */
  portalManagementFees: Array<Maybe<PortalManagementFeeResponse>>;
  /** Portal my cellar */
  portalMyCellar?: Maybe<Array<PortalMyCellarItem>>;
  /** Portal my cellar wine detail */
  portalMyCellarWineDetails?: Maybe<PortalMyCellarWineDetailsItem>;
  portalNotifications: NotificationResponse;
  /** Get Customer Outstanding Management Fees Amount */
  portalOutstandingManagementFeeAmount: PortalOutstandingManagementFeeResponse;
  /** Portal client annualised returns */
  portalPortfolioAnnualisedReturn?: Maybe<PortalPortfolioAnnualisedReturn>;
  /** Portal client's PortfolioBalance */
  portalPortfolioBalance?: Maybe<Array<PortalPortfolioPerformanceItem>>;
  /** Portal portfolio current allocation */
  portalPortfolioCurrentAllocation: PortalPortfolioCurrentAllocationResponse;
  /** Portal portfolio performance over time */
  portalPortfolioPerformanceOverTime: Array<PortalPerformanceHistoricItem>;
  /** Portal portfolio sold holdings */
  portalSoldHoldings?: Maybe<Array<PortalSoldHoldingItem>>;
  /**
   * Get a asset by its Id
   *
   * Equivalent to GET /Product/Asset/:id
   */
  productAsset?: Maybe<Asset>;
  /** Get asset instances by assetId */
  productAssetInstances: Array<AssetInstance>;
  /**
   * Get assets by query parameters
   *
   * Equivalent to GET /Product/Assets
   */
  productAssets: Array<Asset>;
  /**
   * Get wine
   *
   * Equivalent to GET /Product/Wines/:id
   */
  productWine: Wine;
  /**
   * Get wine vintage by wineVintageId
   *
   * Equivalent to GET /Product/WineVintages/:id
   */
  productWineVintage?: Maybe<WineVintage>;
  /**
   * Get wine vintage by query parameters
   *
   * Equivalent to GET /Product/WineVintages
   */
  productWineVintages: Array<WineVintage>;
  /**
   * Get wines
   *
   * Equivalent to GET /Product/Wines
   */
  productWines: Array<Wine>;
  realisedGains: Scalars['Float']['output'];
  recurringPaymentPrices?: Maybe<Array<RecurringPaymentPriceItem>>;
  recurringPayments?: Maybe<Array<RecurringPaymentResponse>>;
  searchActiveMarkets: ActiveMarketResult;
  searchWineMatrix: WineMatrixResult;
  sendSupportMessage?: Maybe<ISendSupportMessage>;
  /**
   * Suggest wine vintages from Elastic Search
   *
   * Equivalent to GET /Search/SuggestWineVintages with indexName 'wine-vintage'
   */
  suggestWineVintages: SuggestWineVintagesResult;
  /**
   * Suggest wines from Elastic Search
   *
   * Equivalent to GET /Search/SuggestWines with indexName 'wine'
   */
  suggestWines: SuggestWinesResult;
  unrealisedGains: Scalars['Float']['output'];
  userExternalPortfolioTotalValue: Scalars['Float']['output'];
  userHasExternalPortfolio: Scalars['Boolean']['output'];
  /**
   * Get if user has a watchList
   *
   * Equivalent to GET /ZellarWatchList/IsUserHasWatchList
   */
  userHasWatchList: Scalars['Boolean']['output'];
  /**
   * Get notifications settings of a user
   *
   * Equivalent to GET /UserNotificationSettings
   */
  userNotificationSettings: NotificationSettingsResponse;
  /**
   * Get notifications of user
   *
   * Equivalent to GET /UserNotifications
   */
  userNotifications: NotificationResponse;
  userPortfolioHighlights: PortfolioHighlights;
  validatePortalEmail: PortalEmailValidationResponse;
  /**
   * Get watchList of user
   *
   * Equivalent to GET /ZellarWatchList/GetUserWatchList
   */
  watchListItems: Array<WatchListItem>;
  zellarClientAddresses: Array<Address>;
  zellarClientGetClient?: Maybe<Client>;
};


export type QueryCalculatedMarketDataArgs = {
  assetId: Scalars['Int']['input'];
};


export type QueryCustomerCardsArgs = {
  currency: Scalars['String']['input'];
};


export type QueryExternalPortfolioUserAssetInstancesArgs = {
  assetId: Scalars['Int']['input'];
};


export type QueryExternalPortfolioUserHasAssetArgs = {
  assetId: Scalars['Int']['input'];
};


export type QueryFinanceGetMonthlyWiseFlowByMonthRangeArgs = {
  monthRange: Scalars['Int']['input'];
};


export type QueryGetActiveMarketsFiltersArgs = {
  filters?: InputMaybe<ActiveMarketFilters>;
  from?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  wineName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomerArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetSupportMessageByUserIdArgs = {
  docRef: IGetSupportMessageByUserIdInput;
};


export type QueryGetWineMatrixFiltersArgs = {
  filters?: InputMaybe<WineMatrixFilters>;
  from?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  tab: Scalars['String']['input'];
  wineName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHistoricalMarketValueArgs = {
  assetIds: Array<Scalars['Int']['input']>;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
};


export type QueryHistoricalMarketValueChangeArgs = {
  assetIds: Array<Scalars['Int']['input']>;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
};


export type QueryInventoriesByDatetimeRangeArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsAssetExistInAnyHoldingsArgs = {
  assetId: Scalars['Int']['input'];
};


export type QueryIsUserHoldingHasAssetArgs = {
  assetId: Scalars['Int']['input'];
};


export type QueryMarketDataArgs = {
  assetId: Scalars['Int']['input'];
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOmsAllTradesByAssetArgs = {
  assetId: Scalars['Int']['input'];
};


export type QueryOmsSpreadByAssetIdArgs = {
  assetId: Scalars['Int']['input'];
};


export type QueryOpenOrdersArgs = {
  assetId: Scalars['Int']['input'];
};


export type QueryPortalHoldingDetailsArgs = {
  id: Scalars['String']['input'];
};


export type QueryPortalMyCellarWineDetailsArgs = {
  stockId: Scalars['String']['input'];
};


export type QueryPortalNotificationsArgs = {
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryPortalPortfolioAnnualisedReturnArgs = {
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPortalPortfolioPerformanceOverTimeArgs = {
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductAssetArgs = {
  assetId: Scalars['Int']['input'];
};


export type QueryProductAssetInstancesArgs = {
  assetId: Scalars['Int']['input'];
};


export type QueryProductAssetsArgs = {
  assetIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  lwin18S?: InputMaybe<Array<Scalars['String']['input']>>;
  wineVintageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductWineArgs = {
  wineId: Scalars['Int']['input'];
};


export type QueryProductWineVintageArgs = {
  wineVintageId: Scalars['Int']['input'];
};


export type QueryProductWineVintagesArgs = {
  lwin11S?: InputMaybe<Array<Scalars['String']['input']>>;
  wineId?: InputMaybe<Scalars['Int']['input']>;
  wineVintageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryProductWinesArgs = {
  lwin7?: InputMaybe<Scalars['String']['input']>;
  wineIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryRecurringPaymentPricesArgs = {
  currency: Scalars['String']['input'];
};


export type QuerySearchActiveMarketsArgs = {
  filters?: InputMaybe<ActiveMarketFilters>;
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortFilter?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  wineName?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchWineMatrixArgs = {
  filters?: InputMaybe<WineMatrixFilters>;
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortFilter?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  tab: Scalars['String']['input'];
  wineName?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySendSupportMessageArgs = {
  docRef: ISendSupportMessageInput;
};


export type QuerySuggestWineVintagesArgs = {
  queryString: Scalars['String']['input'];
};


export type QuerySuggestWinesArgs = {
  queryString: Scalars['String']['input'];
};


export type QueryUserNotificationsArgs = {
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryValidatePortalEmailArgs = {
  emailAddress: Scalars['String']['input'];
};

export type QuickInvestOrder = {
  __typename?: 'QuickInvestOrder';
  asset: Asset;
  direction: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
};

export type RecurringPaymentPriceItem = {
  __typename?: 'RecurringPaymentPriceItem';
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nickName?: Maybe<Scalars['String']['output']>;
  product: Scalars['String']['output'];
  recurringInterval: Scalars['String']['output'];
  recurringIntervalCount: Scalars['Int']['output'];
  unitAmount: Scalars['Float']['output'];
};

export type RecurringPaymentResponse = {
  __typename?: 'RecurringPaymentResponse';
  amount?: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
  frequency?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  portfolioId: Scalars['Int']['output'];
  portfolioName?: Maybe<Scalars['String']['output']>;
  priceId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Region = {
  __typename?: 'Region';
  anglophoneCountryName?: Maybe<Scalars['String']['output']>;
  countryIsoCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  regionName?: Maybe<Scalars['String']['output']>;
  subRegion?: Maybe<Scalars['String']['output']>;
};

export enum RegisteredByApp {
  CultXChina = 'CultXChina'
}

export enum RegistrationType {
  EmailAddress = 'EmailAddress',
  PhoneNumber = 'PhoneNumber'
}

export type SearchBidsFacets = {
  __typename?: 'SearchBidsFacets';
  BidStatus: Scalars['JSON']['output'];
  MyBid: Scalars['JSON']['output'];
  Region: Scalars['JSON']['output'];
  UnitCount: Scalars['JSON']['output'];
  UnitSize: Scalars['JSON']['output'];
  Vintage: Scalars['JSON']['output'];
  WineName: Scalars['JSON']['output'];
};

export type SearchBidsResult = {
  __typename?: 'SearchBidsResult';
  facets: SearchBidsFacets;
  results: Array<BidsResult>;
  total: Scalars['Int']['output'];
};

export type SearchHoldingFacets = {
  __typename?: 'SearchHoldingFacets';
  MarketValue: Scalars['JSON']['output'];
  PercentageDifference: Scalars['JSON']['output'];
  Region: Scalars['JSON']['output'];
  Score: Scalars['JSON']['output'];
  TotalPurchasedPrice: Scalars['JSON']['output'];
  UnitCount: Scalars['JSON']['output'];
  UnitSize: Scalars['JSON']['output'];
  Vintage: Scalars['JSON']['output'];
  WineName: Scalars['JSON']['output'];
};

export type SearchHoldingResult = {
  __typename?: 'SearchHoldingResult';
  facets: SearchHoldingFacets;
  results: Array<HoldingResult>;
  total: Scalars['Int']['output'];
};

export type SearchOffersFacets = {
  __typename?: 'SearchOffersFacets';
  MyOffer: Scalars['JSON']['output'];
  OfferStatus: Scalars['JSON']['output'];
  Region: Scalars['JSON']['output'];
  UnitCount: Scalars['JSON']['output'];
  UnitSize: Scalars['JSON']['output'];
  Vintage: Scalars['JSON']['output'];
  WineName: Scalars['JSON']['output'];
};

export type SearchOffersResult = {
  __typename?: 'SearchOffersResult';
  facets: SearchOffersFacets;
  results: Array<OffersResult>;
  total: Scalars['Int']['output'];
};

export type SearchWatchlistFacets = {
  __typename?: 'SearchWatchlistFacets';
  MarketValue: Scalars['JSON']['output'];
  PercentageDifference: Scalars['JSON']['output'];
  Region: Scalars['JSON']['output'];
  Score: Scalars['JSON']['output'];
  UnitCount: Scalars['JSON']['output'];
  UnitSize: Scalars['JSON']['output'];
  Vintage: Scalars['JSON']['output'];
  WineName: Scalars['JSON']['output'];
};

export type SearchWatchlistResult = {
  __typename?: 'SearchWatchlistResult';
  facets: SearchWatchlistFacets;
  results: Array<WatchlistResult>;
  total: Scalars['Int']['output'];
};

export type SearchWineVintagesFacets = {
  __typename?: 'SearchWineVintagesFacets';
  Appellation: Scalars['JSON']['output'];
  Classification: Scalars['JSON']['output'];
  LiquidityRank?: Maybe<Scalars['JSON']['output']>;
  MarketValue: Scalars['JSON']['output'];
  PercentageDifference: Scalars['JSON']['output'];
  Producer: Scalars['JSON']['output'];
  Region: Scalars['JSON']['output'];
  Score: Scalars['JSON']['output'];
  Vintage: Scalars['JSON']['output'];
  WineName: Scalars['JSON']['output'];
};

export type SearchWineVintagesFacetsResult = {
  __typename?: 'SearchWineVintagesFacetsResult';
  facets: SearchWineVintagesFacets;
};

export type SearchWineVintagesResult = {
  __typename?: 'SearchWineVintagesResult';
  results: Array<WineVintageResult>;
  total: Scalars['Int']['output'];
};

export type SendMessageResult = {
  __typename?: 'SendMessageResult';
  queryId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SpreadOrder = {
  __typename?: 'SpreadOrder';
  assetId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  unitCount?: Maybe<Scalars['Int']['output']>;
  unitSize?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type StripeAddress = {
  __typename?: 'StripeAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type StripeCardItem = {
  __typename?: 'StripeCardItem';
  billingAddress: StripeAddress;
  brand: Scalars['String']['output'];
  country: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  funding: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type StripePaymentInput = {
  amount: Scalars['Float']['input'];
  portfolioId: Scalars['Int']['input'];
};

export type StripePaymentResponse = {
  __typename?: 'StripePaymentResponse';
  clientSecret: Scalars['String']['output'];
  id: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export type StripeRecurringPaymentInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  defaultPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  frequency: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  priceId: Scalars['String']['input'];
};

export type StripeRecurringPaymentResponse = {
  __typename?: 'StripeRecurringPaymentResponse';
  clientSecret: Scalars['String']['output'];
  id: Scalars['String']['output'];
  subId: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  getActiveMarket: LiveActiveMarketResult;
  getMyOrder: Order;
  getMyTrades: TradeSubscription;
  getMyTransferOutRequest: TransferOutRequest;
  getNotification: NotificationRequest;
  getOrderBooksByAssetId: OrderBook;
  getOrderByAssetId: Order;
};


export type SubscriptionGetActiveMarketArgs = {
  wineName?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionGetOrderBooksByAssetIdArgs = {
  assetId: Scalars['Int']['input'];
};


export type SubscriptionGetOrderByAssetIdArgs = {
  assetId: Scalars['Int']['input'];
};

export type SuggestWineVintagesResult = {
  __typename?: 'SuggestWineVintagesResult';
  suggestedAppellation: Array<SuggestedAppellation>;
  suggestedProducer: Array<SuggestedProducer>;
  suggestedRegion: Array<SuggestedRegion>;
  suggests: Array<WineVintageSuggestion>;
};

export type SuggestWinesResult = {
  __typename?: 'SuggestWinesResult';
  suggests: Array<WineSuggestion>;
};

export type SuggestedAppellation = {
  __typename?: 'SuggestedAppellation';
  appellation: Scalars['String']['output'];
};

export type SuggestedProducer = {
  __typename?: 'SuggestedProducer';
  producer: Scalars['String']['output'];
};

export type SuggestedRegion = {
  __typename?: 'SuggestedRegion';
  region: Scalars['String']['output'];
};

export enum TaskStateEnumType {
  Bid = 'Bid',
  Offer = 'Offer'
}

export type Trade = {
  __typename?: 'Trade';
  assetId: Scalars['Int']['output'];
  bid: IFilledOrder;
  id: Scalars['ID']['output'];
  offer: IFilledOrder;
  price: Scalars['Float']['output'];
  size: Scalars['Int']['output'];
};

export type TradeSubscription = {
  __typename?: 'TradeSubscription';
  assetId: Scalars['Int']['output'];
  assetUnitIds: Array<Scalars['String']['output']>;
  bid: BidOfferModel;
  id: Scalars['ID']['output'];
  offer: BidOfferModel;
  tradeDateTime: Scalars['String']['output'];
};

export type TradingInfo = {
  __typename?: 'TradingInfo';
  lastTraded?: Maybe<Scalars['String']['output']>;
  lastTradedValue?: Maybe<Scalars['Float']['output']>;
  tradesMTD: Scalars['Float']['output'];
  tradesYTD: Scalars['Float']['output'];
};

export type TransferOutRequest = {
  __typename?: 'TransferOutRequest';
  assetUnitIds: Array<Scalars['String']['output']>;
  isSuccess: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type UnitSizeDto = {
  __typename?: 'UnitSizeDto';
  buyingTransactionId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  unitSizeId?: Maybe<Scalars['Int']['output']>;
};

export type UpdateDefaultMitCardResponse = {
  __typename?: 'UpdateDefaultMitCardResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type UpdateMitConsentInput = {
  consentFlag: Scalars['Boolean']['input'];
  instrumentId: Scalars['String']['input'];
};

export type UpdateMitConsentResponse = {
  __typename?: 'UpdateMitConsentResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type UpdatePreferencesInput = {
  annualManagementFeePayType?: InputMaybe<Scalars['String']['input']>;
  autoTrade?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  historicManagementFeePayType?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  managementFeePayment?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStripeRecurringPaymentInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  defaultPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  frequency: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type UpdateStripeRecurringPaymentResponse = {
  __typename?: 'UpdateStripeRecurringPaymentResponse';
  hasUpdated: Scalars['Boolean']['output'];
  subscriptionId: Scalars['String']['output'];
};

export type UserDeviceToken = {
  __typename?: 'UserDeviceToken';
  deviceId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  platform: Scalars['Int']['output'];
};

export type UserHolding = {
  __typename?: 'UserHolding';
  activeOfferQuantity: Scalars['Int']['output'];
  asset: Asset;
  calculatedMarketData: CalculatedMarketData;
  totalMarketValuation: Scalars['Float']['output'];
  totalPhysicalQuantity: Scalars['Int']['output'];
  totalPurchasePrice: Scalars['Float']['output'];
  totalQuantityOwned: Scalars['Int']['output'];
};

export type WatchListHolding = {
  __typename?: 'WatchListHolding';
  performance: HoldingPerformanceResponse;
  score: Scalars['Int']['output'];
};

export type WatchListItem = {
  __typename?: 'WatchListItem';
  addedToWatchListDate: Scalars['String']['output'];
  asset: Asset;
  calculatedMarketData: CalculatedMarketData;
};

export type WatchlistResult = {
  __typename?: 'WatchlistResult';
  appellation?: Maybe<Scalars['String']['output']>;
  assetId: Scalars['Int']['output'];
  calculatedMarketData: CalculatedMarketData;
  docId: Scalars['String']['output'];
  marketValue: Scalars['Float']['output'];
  region: Scalars['String']['output'];
  score: Scalars['String']['output'];
  spread?: Maybe<OrderSpread>;
  unitCount: Scalars['Int']['output'];
  unitSize: Scalars['String']['output'];
  vintage: Scalars['Int']['output'];
  watchlistItemId: Scalars['Int']['output'];
  wineName: Scalars['String']['output'];
};

export type Wine = {
  __typename?: 'Wine';
  appellation?: Maybe<Appellation>;
  appellationId?: Maybe<Scalars['Int']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  composition?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstVintage?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isSingleVintage: Scalars['Boolean']['output'];
  lastVintage?: Maybe<Scalars['Int']['output']>;
  lwin7?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  producer?: Maybe<Producer>;
  producerId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Region>;
  regionId?: Maybe<Scalars['Int']['output']>;
  regionalisedWineColour?: Maybe<Scalars['String']['output']>;
  seoFriendlyName?: Maybe<Scalars['String']['output']>;
  sequentialVintages?: Maybe<Scalars['Boolean']['output']>;
  sparkling?: Maybe<Scalars['Boolean']['output']>;
  storingPosition?: Maybe<Scalars['String']['output']>;
  sweetness?: Maybe<Scalars['String']['output']>;
  vintages: Array<WineVintage>;
  wineColourCode?: Maybe<Scalars['String']['output']>;
  wineScores: Array<WineScore>;
};

export type WineMatrix = {
  __typename?: 'WineMatrix';
  data: Array<WineMatrixData>;
  id?: Maybe<Scalars['String']['output']>;
  maxTradeCount?: Maybe<Scalars['Float']['output']>;
  maxUk1b?: Maybe<Scalars['Float']['output']>;
  maxVintage?: Maybe<Scalars['Int']['output']>;
  maxWs1b?: Maybe<Scalars['Float']['output']>;
  minTradeCount?: Maybe<Scalars['Float']['output']>;
  minUk1b?: Maybe<Scalars['Float']['output']>;
  minVintage?: Maybe<Scalars['Int']['output']>;
  minWs1b?: Maybe<Scalars['Float']['output']>;
};

export type WineMatrixData = {
  __typename?: 'WineMatrixData';
  compGrade?: Maybe<Scalars['Int']['output']>;
  liquidity?: Maybe<Scalars['Float']['output']>;
  lwin?: Maybe<Scalars['String']['output']>;
  return1yrWs?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  tradeCount?: Maybe<Scalars['Int']['output']>;
  ukPriceMin?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  vintage?: Maybe<Scalars['String']['output']>;
  wineName?: Maybe<Scalars['String']['output']>;
  wsGrade?: Maybe<Scalars['Float']['output']>;
  wsPrice?: Maybe<Scalars['Float']['output']>;
};

export type WineMatrixFilters = {
  bottlePrice?: InputMaybe<Scalars['String']['input']>;
  classification?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  liquidity?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  wsGrade?: InputMaybe<Scalars['String']['input']>;
};

export type WineMatrixFiltersResult = {
  __typename?: 'WineMatrixFiltersResult';
  bottlePrice?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  classification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  country?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  liquidity?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  producer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  region?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  score?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  tier?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  wsGrade?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type WineMatrixResult = {
  __typename?: 'WineMatrixResult';
  results: Array<WineMatrix>;
  total: Scalars['Int']['output'];
};

export type WineScore = {
  __typename?: 'WineScore';
  score?: Maybe<Scalars['Float']['output']>;
  scoreDate?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  tastingNotes?: Maybe<Scalars['String']['output']>;
};

export type WineSearcherOffer = {
  __typename?: 'WineSearcherOffer';
  lwin18: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type WineSuggestion = {
  __typename?: 'WineSuggestion';
  wineId: Scalars['Int']['output'];
  wineName: Scalars['String']['output'];
};

export type WineVintage = {
  __typename?: 'WineVintage';
  alcoholPct?: Maybe<Scalars['Float']['output']>;
  assets: Array<Asset>;
  calculatedMarketData: CalculatedMarketData;
  closureType?: Maybe<Scalars['String']['output']>;
  drinkingWindow: WineVintageDrinkingWindow;
  id: Scalars['Int']['output'];
  imageFileName?: Maybe<Scalars['String']['output']>;
  lwin11?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  vintage: Scalars['Int']['output'];
  wine: Wine;
  wineId: Scalars['Int']['output'];
  wineScores: Array<WineScore>;
};

export type WineVintageDrinkingWindow = {
  __typename?: 'WineVintageDrinkingWindow';
  advice: Scalars['String']['output'];
  dateFrom: Scalars['String']['output'];
  dateTo: Scalars['String']['output'];
};

export type WineVintageResult = {
  __typename?: 'WineVintageResult';
  appellation?: Maybe<Scalars['String']['output']>;
  calculatedMarketData: CalculatedMarketData;
  classification?: Maybe<Scalars['String']['output']>;
  defaultAsset: Asset;
  defaultAssetId: Scalars['Int']['output'];
  drinkingWindow: WineVintageDrinkingWindow;
  lastTradeDate?: Maybe<Scalars['String']['output']>;
  lastTradePrice?: Maybe<Scalars['Float']['output']>;
  lwin7: Scalars['String']['output'];
  lwin11: Scalars['String']['output'];
  marketData: MarketData;
  marketValue: Scalars['Float']['output'];
  percentageDifference?: Maybe<Scalars['String']['output']>;
  producer?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  score?: Maybe<Scalars['String']['output']>;
  spread?: Maybe<OrderSpread>;
  unitCount: Scalars['Int']['output'];
  unitSize: Scalars['String']['output'];
  vintage: Scalars['Int']['output'];
  wineColour?: Maybe<Scalars['String']['output']>;
  wineId: Scalars['Int']['output'];
  wineName: Scalars['String']['output'];
  wineVintageId: Scalars['Int']['output'];
};


export type WineVintageResultMarketDataArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};

export type WineVintageSuggestion = {
  __typename?: 'WineVintageSuggestion';
  appellation: Scalars['String']['output'];
  defaultAssetId: Scalars['Int']['output'];
  lwin11: Scalars['String']['output'];
  producer: Scalars['String']['output'];
  region: Scalars['String']['output'];
  vintage: Scalars['Int']['output'];
  wineId: Scalars['Int']['output'];
  wineName: Scalars['String']['output'];
  wineVintageId: Scalars['Int']['output'];
};

export type WithdrawConfirmationInput = {
  accountName: Scalars['String']['input'];
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  bic?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
};

export type WithdrawConfirmationResponse = {
  __typename?: 'WithdrawConfirmationResponse';
  accountName: Scalars['String']['output'];
  accountNumber?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  bic?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  sortCode?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type UpdateAddressMutationMutationVariables = Exact<{
  addressId: Scalars['String']['input'];
  address: AddressInput;
}>;


export type UpdateAddressMutationMutation = { __typename?: 'Mutation', zellarClientUpdateAddress: { __typename?: 'Address', addressId: string } };

export type AddAddressMutationMutationVariables = Exact<{
  address: AddressInput;
}>;


export type AddAddressMutationMutation = { __typename?: 'Mutation', zellarClientAddAddress: { __typename?: 'Address', addressId: string } };

export type BidForAssetNoAuthQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type BidForAssetNoAuthQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, spread?: { __typename?: 'OrderSpread', highestBid?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null } | null } | null };

export type BidForAssetWithAuthQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type BidForAssetWithAuthQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, spread?: { __typename?: 'OrderSpread', highestBid?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null } | null } | null, authUser: { __typename?: 'AuthUser', userId: string } };

export type CellarQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CellarQueryQuery = { __typename?: 'Query', imsRegionSummary: Array<{ __typename?: 'ImsRegionSummary', regionName: string, totalBottles: number }> };

export type ParentAssetQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type ParentAssetQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, unitCount: number, unitSize: string, vintage: { __typename?: 'WineVintage', wine: { __typename?: 'Wine', name: string } } } | null };

export type LoginMutationVariables = Exact<{
  loginRequestInput: AuthLoginRequestInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', authLogin: { __typename?: 'AuthLoginResponse', accessToken?: string | null, refreshToken?: string | null, userToken?: string | null, mfaToken?: string | null } };

export type GetMfaAuthenticatorsMutationVariables = Exact<{
  getMfaAuthenticatorsRequestInput: AuthGetMfaAuthenticatorsRequestInput;
}>;


export type GetMfaAuthenticatorsMutation = { __typename?: 'Mutation', authMfaAuthenticators: { __typename?: 'AuthGetMfaAuthenticatorsResponse', mfaAuthenticators: Array<{ __typename?: 'AuthMfaAuthenticator', id: string, active: boolean, authenticatorType: string, name: string, oobChannel: string }> } };

export type IssueMfaChallengeMutationVariables = Exact<{
  mfaChallengeRequestInput: AuthMfaChallengeRequestInput;
}>;


export type IssueMfaChallengeMutation = { __typename?: 'Mutation', authMfaChallenge: { __typename?: 'AuthMfaChallengeResponse', challengeType: string, oobCode: string } };

export type MultipleAssetsWithHoldingsQueryVariables = Exact<{
  assetIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type MultipleAssetsWithHoldingsQuery = { __typename?: 'Query', productAssets: Array<{ __typename?: 'Asset', id: number, marketValue?: number | null, releasePrice?: number | null, calculatedMarketData?: { __typename?: 'CalculatedMarketData', liquidityScore?: number | null, combinedScore?: number | null, performance: { __typename?: 'HoldingPerformanceResponse', percentageDifference?: number | null } } | null, spread?: { __typename?: 'OrderSpread', highestBid?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null, lowestOffer?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null } | null, vintage: { __typename?: 'WineVintage', id: number, vintage: number, drinkingWindow: { __typename?: 'WineVintageDrinkingWindow', advice: string } }, tradingInfo: { __typename?: 'TradingInfo', lastTraded?: string | null, tradesMTD: number, tradesYTD: number } }> };

export type MarketDatasByAssetIdsQueryVariables = Exact<{
  assetIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  marketDataDateFrom?: InputMaybe<Scalars['String']['input']>;
  marketDataDateTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarketDatasByAssetIdsQuery = { __typename?: 'Query', productAssets: Array<{ __typename?: 'Asset', id: number, vintage: { __typename?: 'WineVintage', id: number, vintage: number, wine: { __typename?: 'Wine', id: number, name: string } }, marketData: { __typename?: 'MarketData', wineSearcher: any } }> };

export type GetUserAccountDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAccountDataQuery = { __typename?: 'Query', authUser: { __typename?: 'AuthUser', userId: string, emailAddress: string, firstName: string, surname: string, dateOfBirth?: string | null } };

export type UpdateUserDataMutationVariables = Exact<{
  user: AuthUpdateUserDtoInput;
}>;


export type UpdateUserDataMutation = { __typename?: 'Mutation', authUserUpdate: { __typename?: 'AuthUser', userId: string } };

export type UpdateUserPasswordMutationVariables = Exact<{
  passwordData: AuthChangePasswordInput;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', authChangePassword: { __typename?: 'AuthChangePasswordResponse', wasPasswordChanged: boolean } };

export type SubmitOneTimePasscodeMutationVariables = Exact<{
  args: AuthMfaOobCodeVerifyRequestInput;
}>;


export type SubmitOneTimePasscodeMutation = { __typename?: 'Mutation', authMfaVerify: { __typename?: 'AuthMfaOobCodeVerifyResponse', accessToken: string, idToken: string, userToken: string, refreshToken: string, error?: string | null, errorDescription?: string | null } };

export type OfferForAssetNoAuthQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type OfferForAssetNoAuthQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, spread?: { __typename?: 'OrderSpread', lowestOffer?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null } | null } | null };

export type OfferForAssetWithAuthQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type OfferForAssetWithAuthQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, spread?: { __typename?: 'OrderSpread', lowestOffer?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null } | null } | null, authUser: { __typename?: 'AuthUser', userId: string } };

export type OrderBookQueryVariables = Exact<{
  wineVintageId: Scalars['Int']['input'];
}>;


export type OrderBookQuery = { __typename?: 'Query', productWineVintage?: { __typename?: 'WineVintage', assets: Array<{ __typename?: 'Asset', id: number, unitCount: number, unitSize: string, openOrders: Array<{ __typename?: 'BookedOrder', direction: number, price: number, outstandingQuantity: number }>, recentWineSearcherOffer: { __typename?: 'OffersResponse', offers: Array<{ __typename?: 'WineSearcherOffer', price: number }> }, tradingInfo: { __typename?: 'TradingInfo', lastTraded?: string | null, lastTradedValue?: number | null } }> } | null };

export type OmsOpenOrdersQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type OmsOpenOrdersQuery = { __typename?: 'Query', openOrders: Array<{ __typename?: 'BookedOrder', id: string, userId: string, price: number, direction: number, quantity: number }> };

export type OrderFormQueryQueryVariables = Exact<{
  skipOrder: Scalars['Boolean']['input'];
}>;


export type OrderFormQueryQuery = { __typename?: 'Query', availableBalance: number, financeCurrentBalance?: { __typename?: 'FinancialOperationCurrentBalance', currentBalanceGbp: number } | null, authUser: { __typename?: 'AuthUser', userId: string, emailAddress: string, firstName: string, surname: string, kycStatus?: KycStatus | null, accountType?: string | null, mitConsentedFlag?: boolean | null }, omsGetMyOrders?: Array<{ __typename?: 'BookedOrder', id: string, clientOrderId: string, status: string, price: number, direction: number, cancelled: boolean, submittedTimeUtc: string, outstandingQuantity: number, quantity: number, asset: { __typename?: 'Asset', id: number, unitSize: string, unitCount: number, spread?: { __typename?: 'OrderSpread', lowestOffer?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null, highestBid?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null } | null, vintage: { __typename?: 'WineVintage', id: number, imageFileName?: string | null, vintage: number, calculatedMarketData: { __typename?: 'CalculatedMarketData', combinedScore?: number | null }, wine: { __typename?: 'Wine', id: number, name: string, region?: { __typename?: 'Region', name: string } | null, appellation?: { __typename?: 'Appellation', name: string } | null } } }, executableWindow: { __typename?: 'ExecutableWindow', endTime?: string | null } }> };

export type WineIdForAssetQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type WineIdForAssetQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', vintage: { __typename?: 'WineVintage', id: number } } | null };

export type ProductAssetWatchListByAssetIdQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type ProductAssetWatchListByAssetIdQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, productUrn?: string | null, marketValue?: number | null, vintages: Array<{ __typename?: 'WineVintage', id: number, vintage: number, assets: Array<{ __typename?: 'Asset', id: number, unitSize: string, unitCount: number }> }>, vintage: { __typename?: 'WineVintage', id: number, vintage: number, imageFileName?: string | null, wine: { __typename?: 'Wine', id: number, name: string, seoFriendlyName?: string | null } } } | null };

export type AssetByIdQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type AssetByIdQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, vintage: { __typename?: 'WineVintage', id: number, vintage: number, alcoholPct?: number | null, wine: { __typename?: 'Wine', id: number, regionalisedWineColour?: string | null, sparkling?: boolean | null, country?: string | null, sweetness?: string | null, storingPosition?: string | null, classification?: string | null, producer?: { __typename?: 'Producer', id: number, title?: string | null, name: string } | null, region?: { __typename?: 'Region', id: number, name: string } | null, appellation?: { __typename?: 'Appellation', id: number, name: string } | null } } } | null };

export type VintageScoresQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type VintageScoresQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', vintage: { __typename?: 'WineVintage', vintage: number }, vintages: Array<{ __typename?: 'WineVintage', id: number, vintage: number, calculatedMarketData: { __typename?: 'CalculatedMarketData', combinedScore?: number | null, currentPrice?: number | null } }> } | null };

export type GetMyTradesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyTradesQuery = { __typename?: 'Query', omsGetMyTrades: Array<{ __typename?: 'MyTrades', id: string, price: number, tradeTime: string, quantity: number, totalPrice: number, offer: { __typename?: 'Offer', userId: string, direction: number }, bid: { __typename?: 'Bid', userId: string, direction: number }, asset: { __typename?: 'Asset', id: number, unitSize: string, unitCount: number, vintage: { __typename?: 'WineVintage', id: number, vintage: number, wine: { __typename?: 'Wine', id: number, name: string, appellation?: { __typename?: 'Appellation', name: string } | null, region?: { __typename?: 'Region', name: string } | null } } } }>, authUser: { __typename?: 'AuthUser', userId: string } };

export type RegisterMutationVariables = Exact<{
  registerUserInput: AuthRegisterUserInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', authRegister: { __typename?: 'AuthUser', userId: string } };

export type ExpandedSearchResultDataQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type ExpandedSearchResultDataQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', calculatedMarketData?: { __typename?: 'CalculatedMarketData', liquidityScore?: number | null } | null, tradingInfo: { __typename?: 'TradingInfo', lastTraded?: string | null, lastTradedValue?: number | null }, vintage: { __typename?: 'WineVintage', imageFileName?: string | null, drinkingWindow: { __typename?: 'WineVintageDrinkingWindow', advice: string, dateFrom: string, dateTo: string }, wine: { __typename?: 'Wine', sparkling?: boolean | null, classification?: string | null, producer?: { __typename?: 'Producer', id: number, name: string } | null, region?: { __typename?: 'Region', id: number, name: string } | null } }, spread?: { __typename?: 'OrderSpread', percentageDifference?: number | null } | null } | null };

export type GetTopMoversMutationVariables = Exact<{
  queryString: Scalars['String']['input'];
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  sortFilter?: InputMaybe<Scalars['String']['input']>;
  filterNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetTopMoversMutation = { __typename?: 'Mutation', searchWineVintages: { __typename?: 'SearchWineVintagesResult', results: Array<{ __typename?: 'WineVintageResult', wineId: number, wineVintageId: number, defaultAssetId: number, wineName: string, vintage: number, calculatedMarketData: { __typename?: 'CalculatedMarketData', performance: { __typename?: 'HoldingPerformanceResponse', percentageDifference?: number | null } }, defaultAsset: { __typename?: 'Asset', vintage: { __typename?: 'WineVintage', imageFileName?: string | null } } }> } };

export type GetRecentTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentTransactionsQuery = { __typename?: 'Query', financeGetRecent: Array<{ __typename?: 'FinancialRecentOperation', operationType: string, operationAmountGbp: number, operationSource?: string | null, operationDate: string }> };

export type WatchlistQueryVariables = Exact<{ [key: string]: never; }>;


export type WatchlistQuery = { __typename?: 'Query', watchListItems: Array<{ __typename?: 'WatchListItem', asset: { __typename?: 'Asset', id: number } }> };

export type AddAssetToWatchListMutationVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type AddAssetToWatchListMutation = { __typename?: 'Mutation', addAssetToWatchList: { __typename?: 'AddToWatchListResponse', assetId: number } };

export type AddToExternalPortfolioMutationVariables = Exact<{
  assetId: Scalars['Int']['input'];
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  purchaseDate?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
}>;


export type AddToExternalPortfolioMutation = { __typename?: 'Mutation', externalPortfolioAddExternalPortfolio: number };

export type BuyNowMutationVariables = Exact<{
  buyItNowInitiatedInput?: InputMaybe<BuyItNowInitiatedInput>;
}>;


export type BuyNowMutation = { __typename?: 'Mutation', buyItNow: { __typename?: 'BuyItNowInitiatedResponse', initiated: boolean, errorMessage?: string | null, clientOrderId?: string | null } };

export type CancelOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder: string };

export type ConfirmManualBankTransferMutationVariables = Exact<{ [key: string]: never; }>;


export type ConfirmManualBankTransferMutation = { __typename?: 'Mutation', confirmManualBankTransfer: { __typename?: 'ConfirmBankTransferResponse', isSuccess: boolean, errorMessage?: string | null } };

export type CreateBidMutationVariables = Exact<{
  createBidVariables: CreateOrderInput;
}>;


export type CreateBidMutation = { __typename?: 'Mutation', bid: string };

export type CreateCardPaymentMutationMutationVariables = Exact<{
  args: CardPaymentInput;
}>;


export type CreateCardPaymentMutationMutation = { __typename?: 'Mutation', createCardPayment: { __typename?: 'CardPaymentResponse', id?: string | null, status: string, errorMessage?: string | null, redirectUrl?: string | null } };

export type CreateOfferMutationVariables = Exact<{
  createOfferVariables: CreateOrderInput;
}>;


export type CreateOfferMutation = { __typename?: 'Mutation', offer: string };

export type DeleteAddressMutationVariables = Exact<{
  addressId: Scalars['String']['input'];
}>;


export type DeleteAddressMutation = { __typename?: 'Mutation', zellarClientDeleteAddress: { __typename?: 'AddressDeletedResult', deletedAddressId: string } };

export type DeleteAssetFromWatchListMutationVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type DeleteAssetFromWatchListMutation = { __typename?: 'Mutation', deleteAssetFromWatchList: number };

export type DeleteFromExternalPortfolioMutationVariables = Exact<{
  externalPortfolioId: Scalars['Int']['input'];
}>;


export type DeleteFromExternalPortfolioMutation = { __typename?: 'Mutation', externalPortfolioRemoveFromExternalPortfolio: number };

export type DeletePaymentCardMutationVariables = Exact<{
  instrumentId: Scalars['String']['input'];
}>;


export type DeletePaymentCardMutation = { __typename?: 'Mutation', deleteCardDetail: { __typename?: 'CardDetailDeletedResult', isSuccess?: boolean | null, errorMessage?: string | null } };

export type TransferInventoryOutMutationVariables = Exact<{
  assetUnitIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type TransferInventoryOutMutation = { __typename?: 'Mutation', transferInventoryOut: Array<string> };

export type KycInitiateMutationVariables = Exact<{
  input: KycInitiateInput;
}>;


export type KycInitiateMutation = { __typename?: 'Mutation', kycInitiate: { __typename?: 'KycInitiateResponse', isKycInitiated: boolean, errorMessage?: string | null } };

export type RefreshAccessTokenMutationVariables = Exact<{
  input: AuthRefreshAccessTokenRequestInput;
}>;


export type RefreshAccessTokenMutation = { __typename?: 'Mutation', authRefreshAccessToken: { __typename?: 'AuthRefreshAccessTokenResponse', accessToken: string, refreshToken: string, userToken: string } };

export type SearchWineVintagesFacetsMutationVariables = Exact<{
  queryString: Scalars['String']['input'];
  filterNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  preQueryString?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchWineVintagesFacetsMutation = { __typename?: 'Mutation', searchWineVintagesFacets: { __typename?: 'SearchWineVintagesFacetsResult', facets: { __typename?: 'SearchWineVintagesFacets', Region: any, MarketValue: any, WineName: any, Score: any, PercentageDifference: any, Vintage: any, Appellation: any, Classification: any, Producer: any, LiquidityRank?: any | null } } };

export type SearchWineVintagesMutationVariables = Exact<{
  queryString: Scalars['String']['input'];
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  sortFilter?: InputMaybe<Scalars['String']['input']>;
  preQueryString?: InputMaybe<Scalars['String']['input']>;
  filterNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SearchWineVintagesMutation = { __typename?: 'Mutation', searchWineVintages: { __typename?: 'SearchWineVintagesResult', total: number, results: Array<{ __typename?: 'WineVintageResult', wineVintageId: number, defaultAssetId: number, wineId: number, wineName: string, appellation?: string | null, region: string, vintage: number, score?: string | null, marketValue: number, lastTradePrice?: number | null, lastTradeDate?: string | null, producer?: string | null, classification?: string | null, calculatedMarketData: { __typename?: 'CalculatedMarketData', liquidityScore?: number | null, performance: { __typename?: 'HoldingPerformanceResponse', valueDifference?: number | null, percentageDifference?: number | null } }, defaultAsset: { __typename?: 'Asset', id: number, unitCount: number, unitSize: string, spread?: { __typename?: 'OrderSpread', percentageDifference?: number | null, highestBid?: { __typename?: 'SpreadOrder', price?: number | null, assetId?: number | null, unitCount?: number | null, unitSize?: string | null } | null, lowestOffer?: { __typename?: 'SpreadOrder', price?: number | null, assetId?: number | null, unitCount?: number | null, unitSize?: string | null } | null } | null, vintage: { __typename?: 'WineVintage', id: number, imageFileName?: string | null, wine: { __typename?: 'Wine', sparkling?: boolean | null }, drinkingWindow: { __typename?: 'WineVintageDrinkingWindow', dateFrom: string, dateTo: string, advice: string } } } }> } };

export type UpdateCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'NotificationCategory', id: string, channels?: { __typename?: 'Channels', email: boolean, push: boolean } | null } };

export type UpdateCategoryTypeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
}>;


export type UpdateCategoryTypeMutation = { __typename?: 'Mutation', updateCategoryType: { __typename?: 'NotificationCategoryType', id: string, name?: string | null, description?: string | null, isEnabled: boolean } };

export type UpdateDefaultMitCardMutationVariables = Exact<{
  defaultMitCard: DefaultMitCardInput;
}>;


export type UpdateDefaultMitCardMutation = { __typename?: 'Mutation', updateDefaultMitCard: { __typename?: 'UpdateDefaultMitCardResponse', status: boolean, errorMessage?: string | null } };

export type UpdateMitConsentMutationVariables = Exact<{
  updateMitConsentInput: UpdateMitConsentInput;
}>;


export type UpdateMitConsentMutation = { __typename?: 'Mutation', updateMitConsent: { __typename?: 'UpdateMitConsentResponse', status: boolean, errorMessage?: string | null } };

export type UpdateNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification: { __typename?: 'Notification', id: string, summary: string, description?: string | null, isRead: boolean, createdDateTime: string, updatedDateTime?: string | null } };

export type WithdrawConfirmationMutationVariables = Exact<{
  input: WithdrawConfirmationInput;
}>;


export type WithdrawConfirmationMutation = { __typename?: 'Mutation', withdrawConfirmation: { __typename?: 'WithdrawConfirmationResponse', accountName: string, sortCode?: string | null, accountNumber?: string | null, iban?: string | null, bic?: string | null, amount: number } };

export type AssetsByVintageIdQueryVariables = Exact<{
  wineVintageId: Scalars['Int']['input'];
}>;


export type AssetsByVintageIdQuery = { __typename?: 'Query', productWineVintage?: { __typename?: 'WineVintage', id: number, assets: Array<{ __typename?: 'Asset', id: number, unitSize: string, unitCount: number }> } | null };

export type AvailableBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableBalanceQuery = { __typename?: 'Query', availableBalance: number };

export type AvailableWithdrawalAmountQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableWithdrawalAmountQuery = { __typename?: 'Query', availableWithdrawalAmount?: { __typename?: 'FinancialAvailableWithdrawalAmount', currentWithdrawalGbp: number } | null };

export type BasicAssetByAssetIdQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type BasicAssetByAssetIdQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, unitSize: string, unitCount: number, vintage: { __typename?: 'WineVintage', id: number, vintage: number, wine: { __typename?: 'Wine', id: number, name: string } } } | null };

export type CalculatedMarketDataQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type CalculatedMarketDataQuery = { __typename?: 'Query', calculatedMarketData: { __typename?: 'CalculatedMarketData', liquidityScore?: number | null, currentPrice?: number | null, combinedScore?: number | null, performance: { __typename?: 'HoldingPerformanceResponse', valueDifference?: number | null, percentageDifference?: number | null } } };

export type ExternalPortfolioQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalPortfolioQuery = { __typename?: 'Query', externalPortfolioUserAssets: Array<{ __typename?: 'ExternalPortfolioAsset', quantityOwned: number, purchasePrice?: number | null, totalPurchasePrice: number, calculatedMarketData: { __typename?: 'CalculatedMarketData', combinedScore?: number | null, performance: { __typename?: 'HoldingPerformanceResponse', valueDifference?: number | null, percentageDifference?: number | null } }, asset: { __typename?: 'Asset', id: number, marketValue?: number | null, unitSize: string, unitCount: number, spread?: { __typename?: 'OrderSpread', highestBid?: { __typename?: 'SpreadOrder', price?: number | null } | null, lowestOffer?: { __typename?: 'SpreadOrder', price?: number | null } | null } | null, calculatedMarketData?: { __typename?: 'CalculatedMarketData', combinedScore?: number | null } | null, vintage: { __typename?: 'WineVintage', id: number, imageFileName?: string | null, vintage: number, drinkingWindow: { __typename?: 'WineVintageDrinkingWindow', dateFrom: string, dateTo: string, advice: string }, wine: { __typename?: 'Wine', id: number, name: string, region?: { __typename?: 'Region', name: string } | null } } } }> };

export type ExternalPortfolioInstanceQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type ExternalPortfolioInstanceQuery = { __typename?: 'Query', externalPortfolioUserAssetInstances: Array<{ __typename?: 'ExternalPortfolioInstance', id: number, purchasePrice?: number | null, purchaseDate?: string | null }> };

export type ExternalPortfolioUserHasAssetQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type ExternalPortfolioUserHasAssetQuery = { __typename?: 'Query', externalPortfolioUserHasAsset: boolean };

export type GetActiveMarketsFiltersQueryVariables = Exact<{
  filters?: InputMaybe<ActiveMarketFilters>;
  from?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  wineName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetActiveMarketsFiltersQuery = { __typename?: 'Query', getActiveMarketsFilters?: { __typename?: 'ActiveMarketFiltersResult', producer?: Array<string | null> | null, region?: Array<string | null> | null, unitSize?: Array<string | null> | null, vintage?: Array<string | null> | null, score?: Array<string | null> | null } | null };

export type GetOpenOrdersByAssetIdQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type GetOpenOrdersByAssetIdQuery = { __typename?: 'Query', openOrders: Array<{ __typename?: 'BookedOrder', id: string, assetId: number, direction: number, price: number, quantity: number, submittedTimeUtc: string, userId: string, cancelled: boolean, outstandingQuantity: number, status: string, asset: { __typename?: 'Asset', unitSize: string, unitCount: number, vintage: { __typename?: 'WineVintage', vintage: number, wine: { __typename?: 'Wine', name: string } } } }> };

export type GetWineMatrixFiltersQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  wineName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WineMatrixFilters>;
  tab: Scalars['String']['input'];
}>;


export type GetWineMatrixFiltersQuery = { __typename?: 'Query', getWineMatrixFilters?: { __typename?: 'WineMatrixFiltersResult', country?: Array<string | null> | null, region?: Array<string | null> | null, producer?: Array<string | null> | null, classification?: Array<string | null> | null, tier?: Array<number | null> | null, bottlePrice?: Array<number | null> | null, wsGrade?: Array<number | null> | null, liquidity?: Array<number | null> | null, score?: Array<number | null> | null } | null };

export type GetWineScoresQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type GetWineScoresQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, vintage: { __typename?: 'WineVintage', id: number, wineScores: Array<{ __typename?: 'WineScore', sourceName?: string | null, score?: number | null, scoreDate?: string | null, tastingNotes?: string | null }> } } | null };

export type MarketDataByAssetIdQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  includeWineSearcher: Scalars['Boolean']['input'];
}>;


export type MarketDataByAssetIdQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', marketData: { __typename?: 'MarketData', wineSearcher?: any, performance: { __typename?: 'HoldingPerformanceResponse', valueDifference?: number | null, percentageDifference?: number | null } } } | null };

export type FinanceGetMonthlyWiseFlowByMonthRangeQueryVariables = Exact<{
  monthRange: Scalars['Int']['input'];
}>;


export type FinanceGetMonthlyWiseFlowByMonthRangeQuery = { __typename?: 'Query', financeGetMonthlyWiseFlowByMonthRange?: { __typename?: 'FinancialOperationMonthWiseFlow', monthlyExpenses: Array<{ __typename?: 'MonthlyExpense', monthDate: string, monthName: string, inward: number, outward: number }> } | null };

export type GetNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationSettingsQuery = { __typename?: 'Query', userNotificationSettings: { __typename?: 'NotificationSettingsResponse', categories: Array<{ __typename?: 'NotificationCategory', id: string, name?: string | null, types?: Array<{ __typename?: 'NotificationCategoryType', id: string, name?: string | null, description?: string | null, isEnabled: boolean }> | null, channels?: { __typename?: 'Channels', email: boolean, push: boolean } | null }> } };

export type OmsGetMyOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type OmsGetMyOrdersQuery = { __typename?: 'Query', omsGetMyOrders: Array<{ __typename?: 'BookedOrder', id: string, clientOrderId: string, status: string, price: number, direction: number, cancelled: boolean, submittedTimeUtc: string, outstandingQuantity: number, quantity: number, asset: { __typename?: 'Asset', id: number, unitSize: string, unitCount: number, spread?: { __typename?: 'OrderSpread', lowestOffer?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null, highestBid?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null } | null, vintage: { __typename?: 'WineVintage', id: number, imageFileName?: string | null, vintage: number, calculatedMarketData: { __typename?: 'CalculatedMarketData', combinedScore?: number | null }, wine: { __typename?: 'Wine', id: number, name: string, region?: { __typename?: 'Region', name: string } | null, appellation?: { __typename?: 'Appellation', name: string } | null } } }, executableWindow: { __typename?: 'ExecutableWindow', endTime?: string | null } }> };

export type OwnedAssetInstancesQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type OwnedAssetInstancesQuery = { __typename?: 'Query', productAssetInstances: Array<{ __typename?: 'AssetInstance', id: string, location: string, bondedStatus: string, entryDate: string, traceability: string, purchasePrice: number, valuation?: number | null, assetId: number, transferRequested?: boolean | null }> };

export type OwnedAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type OwnedAssetsQuery = { __typename?: 'Query', holdingsCurrent: Array<{ __typename?: 'UserHolding', totalMarketValuation: number, totalPurchasePrice: number, totalQuantityOwned: number, calculatedMarketData: { __typename?: 'CalculatedMarketData', combinedScore?: number | null, performance: { __typename?: 'HoldingPerformanceResponse', valueDifference?: number | null, percentageDifference?: number | null } }, asset: { __typename?: 'Asset', id: number, unitCount: number, unitSize: string, marketValue?: number | null, spread?: { __typename?: 'OrderSpread', highestBid?: { __typename?: 'SpreadOrder', userId: string, price?: number | null, quantity: number } | null, lowestOffer?: { __typename?: 'SpreadOrder', userId: string, price?: number | null, quantity: number } | null } | null, vintage: { __typename?: 'WineVintage', id: number, imageFileName?: string | null, vintage: number, wine: { __typename?: 'Wine', id: number, name: string, region?: { __typename?: 'Region', id: number, name: string } | null, appellation?: { __typename?: 'Appellation', id: number, name: string } | null }, drinkingWindow: { __typename?: 'WineVintageDrinkingWindow', dateFrom: string, dateTo: string, advice: string } } } }> };

export type PaymentReferenceQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentReferenceQueryQuery = { __typename?: 'Query', paymentReferenceNumber?: string | null };

export type InventoriesByDatetimeRangeQueryVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type InventoriesByDatetimeRangeQuery = { __typename?: 'Query', inventoriesByDatetimeRange: any };

export type PortfolioUserHasAssetQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type PortfolioUserHasAssetQuery = { __typename?: 'Query', isUserHoldingHasAsset: boolean };

export type ProductDataWithUserIdByAssetIdQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type ProductDataWithUserIdByAssetIdQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, vintage: { __typename?: 'WineVintage', id: number, vintage: number, wine: { __typename?: 'Wine', id: number, name: string } } } | null, authUser: { __typename?: 'AuthUser', userId: string } };

export type ProductDataQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type ProductDataQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, vintage: { __typename?: 'WineVintage', id: number, vintage: number, wine: { __typename?: 'Wine', id: number, name: string } } } | null };

export type SearchActiveMarketsQueryVariables = Exact<{
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortFilter?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  wineName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ActiveMarketFilters>;
}>;


export type SearchActiveMarketsQuery = { __typename?: 'Query', searchActiveMarkets: { __typename?: 'ActiveMarketResult', total: number, results: Array<{ __typename?: 'ActiveMarket', assetId: number, productUrn?: string | null, marketValue: number, lwin18: string, score?: number | null, region: string, producer?: string | null, wineUnitSize?: number | null, unitSize: string, unitCount: number, imageFileName?: string | null, vintage: number, wineName: string, spread?: number | null, highestBid: { __typename?: 'ActiveMarketOrder', createdDate?: string | null, price?: number | null }, lowestOffer: { __typename?: 'ActiveMarketOrder', createdDate?: string | null, price?: number | null } }> } };

export type SearchWineMatrixQueryVariables = Exact<{
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  tab: Scalars['String']['input'];
  sortFilter?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  wineName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WineMatrixFilters>;
}>;


export type SearchWineMatrixQuery = { __typename?: 'Query', searchWineMatrix: { __typename?: 'WineMatrixResult', total: number, results: Array<{ __typename?: 'WineMatrix', id?: string | null, maxVintage?: number | null, minVintage?: number | null, maxTradeCount?: number | null, minTradeCount?: number | null, maxWs1b?: number | null, minWs1b?: number | null, maxUk1b?: number | null, minUk1b?: number | null, data: Array<{ __typename?: 'WineMatrixData', lwin?: string | null, wineName?: string | null, vintage?: string | null, wsGrade?: number | null, liquidity?: number | null, tradeCount?: number | null, score?: number | null, return1yrWs?: number | null, compGrade?: number | null, wsPrice?: number | null, ukPriceMin?: number | null, value?: number | null }> }> } };

export type OmsSpreadByAssetIdQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type OmsSpreadByAssetIdQuery = { __typename?: 'Query', omsSpreadByAssetId: { __typename?: 'OrderSpread', percentageDifference?: number | null } };

export type PaymentGetCardDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentGetCardDetailsQuery = { __typename?: 'Query', paymentGetCardDetails?: Array<{ __typename?: 'CardDetailResponse', instrumentId?: string | null, last4?: string | null, clientName?: string | null, expiry?: string | null, scheme?: string | null, mitConsentedFlag?: boolean | null, defaultMitFlag?: boolean | null }> | null };

export type SuggestWineVintagesQueryVariables = Exact<{
  queryString: Scalars['String']['input'];
}>;


export type SuggestWineVintagesQuery = { __typename?: 'Query', suggestWineVintages: { __typename?: 'SuggestWineVintagesResult', suggests: Array<{ __typename?: 'WineVintageSuggestion', wineName: string, region: string, defaultAssetId: number, vintage: number, appellation: string }>, suggestedRegion: Array<{ __typename?: 'SuggestedRegion', region: string }>, suggestedProducer: Array<{ __typename?: 'SuggestedProducer', producer: string }>, suggestedAppellation: Array<{ __typename?: 'SuggestedAppellation', appellation: string }> } };

export type SuggestWinesQueryVariables = Exact<{
  queryString: Scalars['String']['input'];
}>;


export type SuggestWinesQuery = { __typename?: 'Query', suggestWines: { __typename?: 'SuggestWinesResult', suggests: Array<{ __typename?: 'WineSuggestion', wineId: number, wineName: string }> } };

export type UnitSizesByAssetIdQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type UnitSizesByAssetIdQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, unitSize: string, unitCount: number, vintage: { __typename?: 'WineVintage', id: number, assets: Array<{ __typename?: 'Asset', id: number, unitSize: string, unitCount: number }> } } | null };

export type UnitSizeByAssetIdQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type UnitSizeByAssetIdQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, unitSize: string, unitCount: number, tradingInfo: { __typename?: 'TradingInfo', lastTraded?: string | null, lastTradedValue?: number | null } } | null };

export type GetAddressesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddressesQueryQuery = { __typename?: 'Query', zellarClientAddresses: Array<{ __typename?: 'Address', addressId: string, type: string, addressLine1: string, addressLine2?: string | null, addressLine3?: string | null, town: string, county?: string | null, country: string, postcode: string }> };

export type UserExternalPortfolioTotalValueQueryVariables = Exact<{ [key: string]: never; }>;


export type UserExternalPortfolioTotalValueQuery = { __typename?: 'Query', userExternalPortfolioTotalValue: number };

export type UserNotificationsQueryVariables = Exact<{
  from: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type UserNotificationsQuery = { __typename?: 'Query', userNotifications: { __typename?: 'NotificationResponse', total: number, pageSize: number, from: number, totalPages: number, unreadCount: number, results: Array<{ __typename?: 'Notification', id: string, summary: string, category: string, description?: string | null, isRead: boolean, createdDateTime: string, updatedDateTime?: string | null, assetId?: number | null }> } };

export type VintagesByWineIdQueryVariables = Exact<{
  wineId: Scalars['Int']['input'];
}>;


export type VintagesByWineIdQuery = { __typename?: 'Query', productWineVintages: Array<{ __typename?: 'WineVintage', id: number, vintage: number }> };

export type FinanceCurrentBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type FinanceCurrentBalanceQuery = { __typename?: 'Query', financeCurrentBalance?: { __typename?: 'FinancialOperationCurrentBalance', currentBalanceGbp: number } | null };

export type WatchlistItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type WatchlistItemsQuery = { __typename?: 'Query', watchListItems: Array<{ __typename?: 'WatchListItem', calculatedMarketData: { __typename?: 'CalculatedMarketData', combinedScore?: number | null, performance: { __typename?: 'HoldingPerformanceResponse', valueDifference?: number | null, percentageDifference?: number | null } }, asset: { __typename?: 'Asset', id: number, unitSize: string, unitCount: number, marketValue?: number | null, vintage: { __typename?: 'WineVintage', id: number, imageFileName?: string | null, vintage: number, wine: { __typename?: 'Wine', id: number, name: string, country?: string | null, region?: { __typename?: 'Region', id: number, name: string } | null } }, spread?: { __typename?: 'OrderSpread', percentageDifference?: number | null, lowestOffer?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null, highestBid?: { __typename?: 'SpreadOrder', userId: string, price?: number | null } | null } | null } }> };

export type ActiveMarketSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ActiveMarketSubscriptionSubscription = { __typename?: 'Subscription', getActiveMarket: { __typename?: 'LiveActiveMarketResult', total: number, result: { __typename?: 'LiveActiveMarket', assetId: number, imageFileName?: string | null, marketValue?: number | null, region?: string | null, spread?: number | null, toBeRemove?: boolean | null, unitCount?: number | null, unitSize?: string | null, vintage?: number | null, wineName?: string | null, highestBid?: { __typename?: 'ActiveMarketOrder', createdDate?: string | null, price?: number | null } | null, lowestOffer?: { __typename?: 'ActiveMarketOrder', createdDate?: string | null, price?: number | null } | null } } };

export type OnTradeAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnTradeAddedSubscription = { __typename?: 'Subscription', getMyTrades: { __typename?: 'TradeSubscription', assetId: number, assetUnitIds: Array<string>, tradeDateTime: string, bid: { __typename?: 'BidOfferModel', userId: string, id: string, quantity: number, quantityOutstanding: number, price: number }, offer: { __typename?: 'BidOfferModel', userId: string, id: string, quantity: number, quantityOutstanding: number, price: number } } };

export type GetMyTransferOutRequestSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetMyTransferOutRequestSubscription = { __typename?: 'Subscription', getMyTransferOutRequest: { __typename?: 'TransferOutRequest', userId: string, assetUnitIds: Array<string>, isSuccess: boolean } };

export type GetOrderByAssetIdSubscriptionVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type GetOrderByAssetIdSubscription = { __typename?: 'Subscription', getOrderByAssetId: { __typename?: 'Order', asset: { __typename?: 'CosmosAsset', spread?: { __typename?: 'CosmosSpread', percentageDifference?: string | null, highestBid?: { __typename?: 'CosmosBidOffer', price?: number | null } | null, lowestOffer?: { __typename?: 'CosmosBidOffer', price?: number | null } | null } | null } } };

export type GetOrderBooksByAssetIdSubscriptionVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type GetOrderBooksByAssetIdSubscription = { __typename?: 'Subscription', getOrderBooksByAssetId: { __typename?: 'OrderBook', assetId: number, lastTradeDate?: string | null, bids?: Array<{ __typename?: 'OrderBookdBidOffer', direction: number, orderId: string, price: number, quantity: number, quantityOutstanding: number } | null> | null, offers?: Array<{ __typename?: 'OrderBookdBidOffer', direction: number, orderId: string, price: number, quantity: number, quantityOutstanding: number } | null> | null } };

export type CanCreateOfferQueryQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type CanCreateOfferQueryQuery = { __typename?: 'Query', productAsset?: { __typename?: 'Asset', id: number, vintage: { __typename?: 'WineVintage', vintage: number } } | null, omsGetMyOrders: Array<{ __typename?: 'BookedOrder', id: string, direction: number, outstandingQuantity: number, status: string, asset: { __typename?: 'Asset', id: number } }>, productAssetInstances: Array<{ __typename?: 'AssetInstance', id: string, transferRequested?: boolean | null, linkedToPhysical?: boolean | null }> };

export type DoesAssetExistInAnyHoldingsQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type DoesAssetExistInAnyHoldingsQuery = { __typename?: 'Query', isAssetExistInAnyHoldings: boolean };

export type HistoricalMarketValueChangeQueryVariables = Exact<{
  assetIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
}>;


export type HistoricalMarketValueChangeQuery = { __typename?: 'Query', historicalMarketValueChange: Array<{ __typename?: 'HistoricalMarketDataChange', wineSearcher: any, assetId: number }> };

export type GetNotificationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationSubscription = { __typename?: 'Subscription', getNotification: { __typename?: 'NotificationRequest', id: string, summary: string, description?: string | null, isRead: boolean, pushData?: any | null, createdDateTime: string, updatedDateTime?: string | null, assetId?: number | null } };

export type AuthResendVerificationEmailMutationVariables = Exact<{
  resendVerificationEmailInput: AuthResendVerificationEmailInput;
}>;


export type AuthResendVerificationEmailMutation = { __typename?: 'Mutation', authResendVerificationEmail: { __typename?: 'AuthResendVerificationEmailResponse', wasVerificationEmailResent: boolean } };

export type TotalCountOfAssetUnitsOnOfferQueryVariables = Exact<{
  assetId: Scalars['Int']['input'];
}>;


export type TotalCountOfAssetUnitsOnOfferQuery = { __typename?: 'Query', openOrders: Array<{ __typename?: 'BookedOrder', id: string, status: string, outstandingQuantity: number, direction: number, userId: string }> };

export type UnrealisedGainsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnrealisedGainsQuery = { __typename?: 'Query', unrealisedGains: number };

export type UserDetailsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDetailsQueryQuery = { __typename?: 'Query', authUser: { __typename?: 'AuthUser', userId: string, emailAddress: string, firstName: string, surname: string, kycStatus?: KycStatus | null, accountType?: string | null, mitConsentedFlag?: boolean | null } };

export type UserPortfolioHighlightsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPortfolioHighlightsQuery = { __typename?: 'Query', userPortfolioHighlights: { __typename?: 'PortfolioHighlights', portfolioValue: number, totalContributions: number, simpleReturn: number } };

export type ResetPasswordMutationMutationVariables = Exact<{
  resetPasswordInput: AuthResetPasswordInput;
}>;


export type ResetPasswordMutationMutation = { __typename?: 'Mutation', authResetPassword: { __typename?: 'AuthResetPasswordResponse', emailAddress: string } };


export const UpdateAddressMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAddressMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zellarClientUpdateAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}}]}}]}}]} as unknown as DocumentNode<UpdateAddressMutationMutation, UpdateAddressMutationMutationVariables>;
export const AddAddressMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddAddressMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zellarClientAddAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}}]}}]}}]} as unknown as DocumentNode<AddAddressMutationMutation, AddAddressMutationMutationVariables>;
export const BidForAssetNoAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BidForAssetNoAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BidForAssetNoAuthQuery, BidForAssetNoAuthQueryVariables>;
export const BidForAssetWithAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BidForAssetWithAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<BidForAssetWithAuthQuery, BidForAssetWithAuthQueryVariables>;
export const CellarQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CellarQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imsRegionSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionName"}},{"kind":"Field","name":{"kind":"Name","value":"totalBottles"}}]}}]}}]} as unknown as DocumentNode<CellarQueryQuery, CellarQueryQueryVariables>;
export const ParentAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParentAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ParentAssetQuery, ParentAssetQueryVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loginRequestInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthLoginRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loginRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loginRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"userToken"}},{"kind":"Field","name":{"kind":"Name","value":"mfaToken"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const GetMfaAuthenticatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetMFAAuthenticators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getMfaAuthenticatorsRequestInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthGetMfaAuthenticatorsRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authMfaAuthenticators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"getMfaAuthenticatorsRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getMfaAuthenticatorsRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mfaAuthenticators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"authenticatorType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oobChannel"}}]}}]}}]}}]} as unknown as DocumentNode<GetMfaAuthenticatorsMutation, GetMfaAuthenticatorsMutationVariables>;
export const IssueMfaChallengeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssueMFAChallenge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mfaChallengeRequestInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthMfaChallengeRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authMfaChallenge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mfaChallengeRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mfaChallengeRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challengeType"}},{"kind":"Field","name":{"kind":"Name","value":"oobCode"}}]}}]}}]} as unknown as DocumentNode<IssueMfaChallengeMutation, IssueMfaChallengeMutationVariables>;
export const MultipleAssetsWithHoldingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MultipleAssetsWithHoldings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"marketValue"}},{"kind":"Field","name":{"kind":"Name","value":"releasePrice"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liquidityScore"}},{"kind":"Field","name":{"kind":"Name","value":"performance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"combinedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"drinkingWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastTraded"}},{"kind":"Field","name":{"kind":"Name","value":"tradesMTD"}},{"kind":"Field","name":{"kind":"Name","value":"tradesYTD"}}]}}]}}]}}]} as unknown as DocumentNode<MultipleAssetsWithHoldingsQuery, MultipleAssetsWithHoldingsQueryVariables>;
export const MarketDatasByAssetIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketDatasByAssetIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketDataDateFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketDataDateTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketDataDateFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketDataDateTo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineSearcher"}}]}}]}}]}}]} as unknown as DocumentNode<MarketDatasByAssetIdsQuery, MarketDatasByAssetIdsQueryVariables>;
export const GetUserAccountDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserAccountData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}}]}}]} as unknown as DocumentNode<GetUserAccountDataQuery, GetUserAccountDataQueryVariables>;
export const UpdateUserDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthUpdateUserDtoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authUserUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUserInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<UpdateUserDataMutation, UpdateUserDataMutationVariables>;
export const UpdateUserPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passwordData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthChangePasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authChangePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"changePasswordInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passwordData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wasPasswordChanged"}}]}}]}}]} as unknown as DocumentNode<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const SubmitOneTimePasscodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitOneTimePasscode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthMfaOobCodeVerifyRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authMfaVerify"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mfaOobCodeVerifyRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"idToken"}},{"kind":"Field","name":{"kind":"Name","value":"userToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"errorDescription"}}]}}]}}]} as unknown as DocumentNode<SubmitOneTimePasscodeMutation, SubmitOneTimePasscodeMutationVariables>;
export const OfferForAssetNoAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OfferForAssetNoAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OfferForAssetNoAuthQuery, OfferForAssetNoAuthQueryVariables>;
export const OfferForAssetWithAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OfferForAssetWithAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<OfferForAssetWithAuthQuery, OfferForAssetWithAuthQueryVariables>;
export const OrderBookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderBook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wineVintageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productWineVintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wineVintageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wineVintageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"openOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentWineSearcherOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastTraded"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradedValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrderBookQuery, OrderBookQueryVariables>;
export const OmsOpenOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OmsOpenOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]} as unknown as DocumentNode<OmsOpenOrdersQuery, OmsOpenOrdersQueryVariables>;
export const OrderFormQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderFormQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipOrder"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableBalance"}},{"kind":"Field","name":{"kind":"Name","value":"financeCurrentBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentBalanceGbp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"kycStatus"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"mitConsentedFlag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"omsGetMyOrders"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipOrder"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combinedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appellation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"executableWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"submittedTimeUtc"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]} as unknown as DocumentNode<OrderFormQueryQuery, OrderFormQueryQueryVariables>;
export const WineIdForAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WineIdForAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<WineIdForAssetQuery, WineIdForAssetQueryVariables>;
export const ProductAssetWatchListByAssetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductAssetWatchListByAssetId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productUrn"}},{"kind":"Field","name":{"kind":"Name","value":"vintages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seoFriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketValue"}}]}}]}}]} as unknown as DocumentNode<ProductAssetWatchListByAssetIdQuery, ProductAssetWatchListByAssetIdQueryVariables>;
export const AssetByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssetById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"alcoholPct"}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"regionalisedWineColour"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sparkling"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appellation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sweetness"}},{"kind":"Field","name":{"kind":"Name","value":"storingPosition"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssetByIdQuery, AssetByIdQueryVariables>;
export const VintageScoresDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VintageScores"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combinedScore"}},{"kind":"Field","name":{"kind":"Name","value":"currentPrice"}}]}}]}}]}}]}}]} as unknown as DocumentNode<VintageScoresQuery, VintageScoresQueryVariables>;
export const GetMyTradesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyTrades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"omsGetMyTrades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"tradeTime"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"appellation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<GetMyTradesQuery, GetMyTradesQueryVariables>;
export const RegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Register"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registerUserInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthRegisterUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authRegister"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registerUserInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registerUserInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const ExpandedSearchResultDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExpandedSearchResultData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liquidityScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastTraded"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradedValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}},{"kind":"Field","name":{"kind":"Name","value":"drinkingWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advice"}},{"kind":"Field","name":{"kind":"Name","value":"dateFrom"}},{"kind":"Field","name":{"kind":"Name","value":"dateTo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sparkling"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"selectLowestOffer"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}}]}}]}}]} as unknown as DocumentNode<ExpandedSearchResultDataQuery, ExpandedSearchResultDataQueryVariables>;
export const GetTopMoversDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetTopMovers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterNames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchWineVintages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queryString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterNames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterNames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineId"}},{"kind":"Field","name":{"kind":"Name","value":"wineVintageId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssetId"}},{"kind":"Field","name":{"kind":"Name","value":"wineName"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"performance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTopMoversMutation, GetTopMoversMutationVariables>;
export const GetRecentTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecentTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"financeGetRecent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationType"}},{"kind":"Field","name":{"kind":"Name","value":"operationAmountGbp"}},{"kind":"Field","name":{"kind":"Name","value":"operationSource"}},{"kind":"Field","name":{"kind":"Name","value":"operationDate"}}]}}]}}]} as unknown as DocumentNode<GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables>;
export const WatchlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Watchlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watchListItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<WatchlistQuery, WatchlistQueryVariables>;
export const AddAssetToWatchListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddAssetToWatchList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addAssetToWatchList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}}]}}]}}]} as unknown as DocumentNode<AddAssetToWatchListMutation, AddAssetToWatchListMutationVariables>;
export const AddToExternalPortfolioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddToExternalPortfolio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchasePrice"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchaseDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPortfolioAddExternalPortfolio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"externalPortfolio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"purchasePrice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchasePrice"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"purchaseDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchaseDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}}]}}]}]}}]} as unknown as DocumentNode<AddToExternalPortfolioMutation, AddToExternalPortfolioMutationVariables>;
export const BuyNowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BuyNow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyItNowInitiatedInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BuyItNowInitiatedInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyItNow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"buyItNowInitiatedInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyItNowInitiatedInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiated"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"clientOrderId"}}]}}]}}]} as unknown as DocumentNode<BuyNowMutation, BuyNowMutationVariables>;
export const CancelOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}]}}]} as unknown as DocumentNode<CancelOrderMutation, CancelOrderMutationVariables>;
export const ConfirmManualBankTransferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmManualBankTransfer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmManualBankTransfer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSuccess"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ConfirmManualBankTransferMutation, ConfirmManualBankTransferMutationVariables>;
export const CreateBidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createBidVariables"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createOrderInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createBidVariables"}}}]}]}}]} as unknown as DocumentNode<CreateBidMutation, CreateBidMutationVariables>;
export const CreateCardPaymentMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCardPaymentMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CardPaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCardPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardPayment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<CreateCardPaymentMutationMutation, CreateCardPaymentMutationMutationVariables>;
export const CreateOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createOfferVariables"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createOrderInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createOfferVariables"}}}]}]}}]} as unknown as DocumentNode<CreateOfferMutation, CreateOfferMutationVariables>;
export const DeleteAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zellarClientDeleteAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedAddressId"}}]}}]}}]} as unknown as DocumentNode<DeleteAddressMutation, DeleteAddressMutationVariables>;
export const DeleteAssetFromWatchListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAssetFromWatchList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAssetFromWatchList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}]}]}}]} as unknown as DocumentNode<DeleteAssetFromWatchListMutation, DeleteAssetFromWatchListMutationVariables>;
export const DeleteFromExternalPortfolioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFromExternalPortfolio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalPortfolioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPortfolioRemoveFromExternalPortfolio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"externalPortfolioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalPortfolioId"}}}]}]}}]} as unknown as DocumentNode<DeleteFromExternalPortfolioMutation, DeleteFromExternalPortfolioMutationVariables>;
export const DeletePaymentCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePaymentCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instrumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCardDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"instrumentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instrumentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSuccess"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<DeletePaymentCardMutation, DeletePaymentCardMutationVariables>;
export const TransferInventoryOutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransferInventoryOut"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetUnitIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferInventoryOut"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetUnitIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetUnitIds"}}}]}]}}]} as unknown as DocumentNode<TransferInventoryOutMutation, TransferInventoryOutMutationVariables>;
export const KycInitiateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"KycInitiate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KycInitiateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kycInitiate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"kycInitiateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isKycInitiated"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<KycInitiateMutation, KycInitiateMutationVariables>;
export const RefreshAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthRefreshAccessTokenRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authRefreshAccessToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"refreshAccessTokenRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"userToken"}}]}}]}}]} as unknown as DocumentNode<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>;
export const SearchWineVintagesFacetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SearchWineVintagesFacets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterNames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preQueryString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchWineVintagesFacets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queryString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterNames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterNames"}}},{"kind":"Argument","name":{"kind":"Name","value":"preQueryString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preQueryString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Region"}},{"kind":"Field","name":{"kind":"Name","value":"MarketValue"}},{"kind":"Field","name":{"kind":"Name","value":"WineName"}},{"kind":"Field","name":{"kind":"Name","value":"Score"}},{"kind":"Field","name":{"kind":"Name","value":"PercentageDifference"}},{"kind":"Field","name":{"kind":"Name","value":"Vintage"}},{"kind":"Field","name":{"kind":"Name","value":"Appellation"}},{"kind":"Field","name":{"kind":"Name","value":"Classification"}},{"kind":"Field","name":{"kind":"Name","value":"Producer"}},{"kind":"Field","name":{"kind":"Name","value":"LiquidityRank"}}]}}]}}]}}]} as unknown as DocumentNode<SearchWineVintagesFacetsMutation, SearchWineVintagesFacetsMutationVariables>;
export const SearchWineVintagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SearchWineVintages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preQueryString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterNames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchWineVintages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queryString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"preQueryString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preQueryString"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterNames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterNames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineVintageId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssetId"}},{"kind":"Field","name":{"kind":"Name","value":"wineId"}},{"kind":"Field","name":{"kind":"Name","value":"wineName"}},{"kind":"Field","name":{"kind":"Name","value":"appellation"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"marketValue"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradeDate"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"producer"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liquidityScore"}},{"kind":"Field","name":{"kind":"Name","value":"performance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueDifference"}},{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"selectLowestOffer"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}}]}},{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sparkling"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drinkingWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateFrom"}},{"kind":"Field","name":{"kind":"Name","value":"dateTo"}},{"kind":"Field","name":{"kind":"Name","value":"advice"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchWineVintagesMutation, SearchWineVintagesMutationVariables>;
export const UpdateCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"push"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const UpdateCategoryTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCategoryType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCategoryType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]} as unknown as DocumentNode<UpdateCategoryTypeMutation, UpdateCategoryTypeMutationVariables>;
export const UpdateDefaultMitCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDefaultMitCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultMitCard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DefaultMitCardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDefaultMitCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"defaultMitCard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultMitCard"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<UpdateDefaultMitCardMutation, UpdateDefaultMitCardMutationVariables>;
export const UpdateMitConsentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMitConsent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateMitConsentInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMitConsentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMitConsent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateMitConsentInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateMitConsentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<UpdateMitConsentMutation, UpdateMitConsentMutationVariables>;
export const UpdateNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDateTime"}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const WithdrawConfirmationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WithdrawConfirmation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WithdrawConfirmationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawConfirmation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"sortCode"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<WithdrawConfirmationMutation, WithdrawConfirmationMutationVariables>;
export const AssetsByVintageIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssetsByVintageId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wineVintageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productWineVintage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wineVintageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wineVintageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}}]}}]}}]}}]} as unknown as DocumentNode<AssetsByVintageIdQuery, AssetsByVintageIdQueryVariables>;
export const AvailableBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailableBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableBalance"}}]}}]} as unknown as DocumentNode<AvailableBalanceQuery, AvailableBalanceQueryVariables>;
export const AvailableWithdrawalAmountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailableWithdrawalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableWithdrawalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentWithdrawalGbp"}}]}}]}}]} as unknown as DocumentNode<AvailableWithdrawalAmountQuery, AvailableWithdrawalAmountQueryVariables>;
export const BasicAssetByAssetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BasicAssetByAssetId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}}]}}]}}]} as unknown as DocumentNode<BasicAssetByAssetIdQuery, BasicAssetByAssetIdQueryVariables>;
export const CalculatedMarketDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalculatedMarketData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liquidityScore"}},{"kind":"Field","name":{"kind":"Name","value":"currentPrice"}},{"kind":"Field","name":{"kind":"Name","value":"combinedScore"}},{"kind":"Field","name":{"kind":"Name","value":"performance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueDifference"}},{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}}]}}]}}]} as unknown as DocumentNode<CalculatedMarketDataQuery, CalculatedMarketDataQueryVariables>;
export const ExternalPortfolioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalPortfolio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPortfolioUserAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantityOwned"}},{"kind":"Field","name":{"kind":"Name","value":"purchasePrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalPurchasePrice"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combinedScore"}},{"kind":"Field","name":{"kind":"Name","value":"performance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueDifference"}},{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketValue"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combinedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}},{"kind":"Field","name":{"kind":"Name","value":"drinkingWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateFrom"}},{"kind":"Field","name":{"kind":"Name","value":"dateTo"}},{"kind":"Field","name":{"kind":"Name","value":"advice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExternalPortfolioQuery, ExternalPortfolioQueryVariables>;
export const ExternalPortfolioInstanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalPortfolioInstance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPortfolioUserAssetInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchasePrice"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}}]}}]}}]} as unknown as DocumentNode<ExternalPortfolioInstanceQuery, ExternalPortfolioInstanceQueryVariables>;
export const ExternalPortfolioUserHasAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalPortfolioUserHasAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPortfolioUserHasAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}]}]}}]} as unknown as DocumentNode<ExternalPortfolioUserHasAssetQuery, ExternalPortfolioUserHasAssetQueryVariables>;
export const GetActiveMarketsFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveMarketsFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActiveMarketFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wineName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveMarketsFilters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"wineName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wineName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]} as unknown as DocumentNode<GetActiveMarketsFiltersQuery, GetActiveMarketsFiltersQueryVariables>;
export const GetOpenOrdersByAssetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOpenOrdersByAssetId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"submittedTimeUtc"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOpenOrdersByAssetIdQuery, GetOpenOrdersByAssetIdQueryVariables>;
export const GetWineMatrixFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWineMatrixFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wineName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WineMatrixFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tab"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWineMatrixFilters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"wineName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wineName"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"tab"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tab"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"producer"}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"bottlePrice"}},{"kind":"Field","name":{"kind":"Name","value":"wsGrade"}},{"kind":"Field","name":{"kind":"Name","value":"liquidity"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]} as unknown as DocumentNode<GetWineMatrixFiltersQuery, GetWineMatrixFiltersQueryVariables>;
export const GetWineScoresDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWineScores"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wineScores"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceName"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"scoreDate"}},{"kind":"Field","name":{"kind":"Name","value":"tastingNotes"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWineScoresQuery, GetWineScoresQueryVariables>;
export const MarketDataByAssetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketDataByAssetId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeWineSearcher"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"performance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueDifference"}},{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wineSearcher"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeWineSearcher"}}}]}]}]}}]}}]}}]} as unknown as DocumentNode<MarketDataByAssetIdQuery, MarketDataByAssetIdQueryVariables>;
export const FinanceGetMonthlyWiseFlowByMonthRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FinanceGetMonthlyWiseFlowByMonthRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"monthRange"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"financeGetMonthlyWiseFlowByMonthRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"monthRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"monthRange"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monthlyExpenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monthDate"}},{"kind":"Field","name":{"kind":"Name","value":"monthName"}},{"kind":"Field","name":{"kind":"Name","value":"inward"}},{"kind":"Field","name":{"kind":"Name","value":"outward"}}]}}]}}]}}]} as unknown as DocumentNode<FinanceGetMonthlyWiseFlowByMonthRangeQuery, FinanceGetMonthlyWiseFlowByMonthRangeQueryVariables>;
export const GetNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNotificationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"push"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>;
export const OmsGetMyOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OMSGetMyOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"omsGetMyOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combinedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appellation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"executableWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"submittedTimeUtc"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]} as unknown as DocumentNode<OmsGetMyOrdersQuery, OmsGetMyOrdersQueryVariables>;
export const OwnedAssetInstancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OwnedAssetInstances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAssetInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"bondedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"entryDate"}},{"kind":"Field","name":{"kind":"Name","value":"traceability"}},{"kind":"Field","name":{"kind":"Name","value":"purchasePrice"}},{"kind":"Field","name":{"kind":"Name","value":"valuation"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"transferRequested"}}]}}]}}]} as unknown as DocumentNode<OwnedAssetInstancesQuery, OwnedAssetInstancesQueryVariables>;
export const OwnedAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OwnedAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"holdingsCurrent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalMarketValuation"}},{"kind":"Field","name":{"kind":"Name","value":"totalPurchasePrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalQuantityOwned"}},{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combinedScore"}},{"kind":"Field","name":{"kind":"Name","value":"performance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueDifference"}},{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"marketValue"}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appellation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"drinkingWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateFrom"}},{"kind":"Field","name":{"kind":"Name","value":"dateTo"}},{"kind":"Field","name":{"kind":"Name","value":"advice"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OwnedAssetsQuery, OwnedAssetsQueryVariables>;
export const PaymentReferenceQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentReferenceQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentReferenceNumber"}}]}}]} as unknown as DocumentNode<PaymentReferenceQueryQuery, PaymentReferenceQueryQueryVariables>;
export const InventoriesByDatetimeRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InventoriesByDatetimeRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventoriesByDatetimeRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}]}]}}]} as unknown as DocumentNode<InventoriesByDatetimeRangeQuery, InventoriesByDatetimeRangeQueryVariables>;
export const PortfolioUserHasAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PortfolioUserHasAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUserHoldingHasAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}]}]}}]} as unknown as DocumentNode<PortfolioUserHasAssetQuery, PortfolioUserHasAssetQueryVariables>;
export const ProductDataWithUserIdByAssetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductDataWithUserIdByAssetId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<ProductDataWithUserIdByAssetIdQuery, ProductDataWithUserIdByAssetIdQueryVariables>;
export const ProductDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductDataQuery, ProductDataQueryVariables>;
export const SearchActiveMarketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchActiveMarkets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wineName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActiveMarketFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchActiveMarkets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"wineName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wineName"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"productUrn"}},{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketValue"}},{"kind":"Field","name":{"kind":"Name","value":"lwin18"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"producer"}},{"kind":"Field","name":{"kind":"Name","value":"wineUnitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"wineName"}},{"kind":"Field","name":{"kind":"Name","value":"spread"}}]}}]}}]}}]} as unknown as DocumentNode<SearchActiveMarketsQuery, SearchActiveMarketsQueryVariables>;
export const SearchWineMatrixDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchWineMatrix"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tab"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wineName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WineMatrixFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchWineMatrix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"tab"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tab"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"wineName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wineName"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"maxVintage"}},{"kind":"Field","name":{"kind":"Name","value":"minVintage"}},{"kind":"Field","name":{"kind":"Name","value":"maxTradeCount"}},{"kind":"Field","name":{"kind":"Name","value":"minTradeCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxWs1b"}},{"kind":"Field","name":{"kind":"Name","value":"minWs1b"}},{"kind":"Field","name":{"kind":"Name","value":"maxUk1b"}},{"kind":"Field","name":{"kind":"Name","value":"minUk1b"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lwin"}},{"kind":"Field","name":{"kind":"Name","value":"wineName"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"wsGrade"}},{"kind":"Field","name":{"kind":"Name","value":"liquidity"}},{"kind":"Field","name":{"kind":"Name","value":"tradeCount"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"return1yrWs"}},{"kind":"Field","name":{"kind":"Name","value":"compGrade"}},{"kind":"Field","name":{"kind":"Name","value":"wsPrice"}},{"kind":"Field","name":{"kind":"Name","value":"ukPriceMin"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchWineMatrixQuery, SearchWineMatrixQueryVariables>;
export const OmsSpreadByAssetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OmsSpreadByAssetId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"omsSpreadByAssetId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}}]}}]} as unknown as DocumentNode<OmsSpreadByAssetIdQuery, OmsSpreadByAssetIdQueryVariables>;
export const PaymentGetCardDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentGetCardDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentGetCardDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instrumentId"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"expiry"}},{"kind":"Field","name":{"kind":"Name","value":"scheme"}},{"kind":"Field","name":{"kind":"Name","value":"mitConsentedFlag"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMitFlag"}}]}}]}}]} as unknown as DocumentNode<PaymentGetCardDetailsQuery, PaymentGetCardDetailsQueryVariables>;
export const SuggestWineVintagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuggestWineVintages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestWineVintages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queryString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineName"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssetId"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"appellation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedProducer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedAppellation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appellation"}}]}}]}}]}}]} as unknown as DocumentNode<SuggestWineVintagesQuery, SuggestWineVintagesQueryVariables>;
export const SuggestWinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuggestWines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestWines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queryString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineId"}},{"kind":"Field","name":{"kind":"Name","value":"wineName"}}]}}]}}]}}]} as unknown as DocumentNode<SuggestWinesQuery, SuggestWinesQueryVariables>;
export const UnitSizesByAssetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnitSizesByAssetId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnitSizesByAssetIdQuery, UnitSizesByAssetIdQueryVariables>;
export const UnitSizeByAssetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnitSizeByAssetId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"tradingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastTraded"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradedValue"}}]}}]}}]}}]} as unknown as DocumentNode<UnitSizeByAssetIdQuery, UnitSizeByAssetIdQueryVariables>;
export const GetAddressesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAddressesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zellarClientAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine3"}},{"kind":"Field","name":{"kind":"Name","value":"town"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]}}]} as unknown as DocumentNode<GetAddressesQueryQuery, GetAddressesQueryQueryVariables>;
export const UserExternalPortfolioTotalValueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserExternalPortfolioTotalValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userExternalPortfolioTotalValue"}}]}}]} as unknown as DocumentNode<UserExternalPortfolioTotalValueQuery, UserExternalPortfolioTotalValueQueryVariables>;
export const UserNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unreadCount"}}]}}]}}]} as unknown as DocumentNode<UserNotificationsQuery, UserNotificationsQueryVariables>;
export const VintagesByWineIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VintagesByWineId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productWineVintages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wineId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}}]}}]}}]} as unknown as DocumentNode<VintagesByWineIdQuery, VintagesByWineIdQueryVariables>;
export const FinanceCurrentBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FinanceCurrentBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"financeCurrentBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentBalanceGbp"}}]}}]}}]} as unknown as DocumentNode<FinanceCurrentBalanceQuery, FinanceCurrentBalanceQueryVariables>;
export const WatchlistItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WatchlistItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watchListItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatedMarketData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combinedScore"}},{"kind":"Field","name":{"kind":"Name","value":"performance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueDifference"}},{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}},{"kind":"Field","name":{"kind":"Name","value":"wine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}},{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"marketValue"}}]}}]}}]}}]} as unknown as DocumentNode<WatchlistItemsQuery, WatchlistItemsQueryVariables>;
export const ActiveMarketSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ActiveMarketSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveMarket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}},{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketValue"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"spread"}},{"kind":"Field","name":{"kind":"Name","value":"toBeRemove"}},{"kind":"Field","name":{"kind":"Name","value":"unitCount"}},{"kind":"Field","name":{"kind":"Name","value":"unitSize"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"}},{"kind":"Field","name":{"kind":"Name","value":"wineName"}}]}}]}}]}}]} as unknown as DocumentNode<ActiveMarketSubscriptionSubscription, ActiveMarketSubscriptionSubscriptionVariables>;
export const OnTradeAddedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnTradeAdded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMyTrades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"assetUnitIds"}},{"kind":"Field","name":{"kind":"Name","value":"bid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityOutstanding"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityOutstanding"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeDateTime"}}]}}]}}]} as unknown as DocumentNode<OnTradeAddedSubscription, OnTradeAddedSubscriptionVariables>;
export const GetMyTransferOutRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetMyTransferOutRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMyTransferOutRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"assetUnitIds"}},{"kind":"Field","name":{"kind":"Name","value":"isSuccess"}}]}}]}}]} as unknown as DocumentNode<GetMyTransferOutRequestSubscription, GetMyTransferOutRequestSubscriptionVariables>;
export const GetOrderByAssetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetOrderByAssetId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderByAssetId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highestBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"percentageDifference"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderByAssetIdSubscription, GetOrderByAssetIdSubscriptionVariables>;
export const GetOrderBooksByAssetIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetOrderBooksByAssetId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderBooksByAssetId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradeDate"}},{"kind":"Field","name":{"kind":"Name","value":"bids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityOutstanding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityOutstanding"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderBooksByAssetIdSubscription, GetOrderBooksByAssetIdSubscriptionVariables>;
export const CanCreateOfferQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CanCreateOfferQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vintage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"omsGetMyOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productAssetInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transferRequested"}},{"kind":"Field","name":{"kind":"Name","value":"linkedToPhysical"}}]}}]}}]} as unknown as DocumentNode<CanCreateOfferQueryQuery, CanCreateOfferQueryQueryVariables>;
export const DoesAssetExistInAnyHoldingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DoesAssetExistInAnyHoldings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAssetExistInAnyHoldings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}]}]}}]} as unknown as DocumentNode<DoesAssetExistInAnyHoldingsQuery, DoesAssetExistInAnyHoldingsQueryVariables>;
export const HistoricalMarketValueChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HistoricalMarketValueChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"historicalMarketValueChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wineSearcher"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}}]}}]}}]} as unknown as DocumentNode<HistoricalMarketValueChangeQuery, HistoricalMarketValueChangeQueryVariables>;
export const GetNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"pushData"}},{"kind":"Field","name":{"kind":"Name","value":"createdDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}}]}}]}}]} as unknown as DocumentNode<GetNotificationSubscription, GetNotificationSubscriptionVariables>;
export const AuthResendVerificationEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthResendVerificationEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resendVerificationEmailInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthResendVerificationEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authResendVerificationEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resendVerificationEmailInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resendVerificationEmailInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wasVerificationEmailResent"}}]}}]}}]} as unknown as DocumentNode<AuthResendVerificationEmailMutation, AuthResendVerificationEmailMutationVariables>;
export const TotalCountOfAssetUnitsOnOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TotalCountOfAssetUnitsOnOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"assetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"outstandingQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<TotalCountOfAssetUnitsOnOfferQuery, TotalCountOfAssetUnitsOnOfferQueryVariables>;
export const UnrealisedGainsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnrealisedGains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unrealisedGains"}}]}}]} as unknown as DocumentNode<UnrealisedGainsQuery, UnrealisedGainsQueryVariables>;
export const UserDetailsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserDetailsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"kycStatus"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"mitConsentedFlag"}}]}}]}}]} as unknown as DocumentNode<UserDetailsQueryQuery, UserDetailsQueryQueryVariables>;
export const UserPortfolioHighlightsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserPortfolioHighlights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userPortfolioHighlights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolioValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalContributions"}},{"kind":"Field","name":{"kind":"Name","value":"simpleReturn"}}]}}]}}]} as unknown as DocumentNode<UserPortfolioHighlightsQuery, UserPortfolioHighlightsQueryVariables>;
export const ResetPasswordMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPasswordMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resetPasswordInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthResetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authResetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resetPasswordInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resetPasswordInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]} as unknown as DocumentNode<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables>;